import { Component, OnInit, ViewChild, ElementRef, ViewChildren, AfterViewInit } from '@angular/core';
import { transition } from '@angular/core/src/animation/dsl';
import { Observable } from 'rxjs/Observable';
import { ScrollEvent } from 'ngx-scroll-event';
import { UploadEvent, UploadFile, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';

import { SellerApiService } from '../service/seller-api.service';
import { CognitoUtil } from '../../authentication/service/cognito.service';
import { NewProjects, ProjectDetails, AgreementCreateObj, AgreementData, ChangeAgreementObject, ChangeAgreementDbObject } from '../seller';
import { FirebaseHelperService } from '../../core/firebase/firebase-helper.service';
import { MessageModel } from '../../core/firebase/models/message.model';
import { CommonConstants } from '../../core/common.constants';
import * as moment from 'moment';
import * as JSZip from 'jszip';
import * as JSZipUtils from 'jszip';
import * as JSZipSupport from 'jszip';
import { NgForm } from '@angular/forms';
import { GlobalEventsManager } from '../../app-global-events-manager';
import { environment } from '../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { of } from 'rxjs';

// jQuery Sign $
declare let $: any;


@Component({
  selector: 'app-safetybox',
  templateUrl: './safetybox.component.html',
  styleUrls: ['./safetybox.component.scss']
})
export class SafetyboxComponent implements OnInit, AfterViewInit {

  userFirstname: string;
  buyerDisplayName: string;
  agreedProjects: Array<NewProjects> = [];
  acceptedProjects: Array<NewProjects> = [];
  archiveProjects: Array<NewProjects> = [];
  completedProjects: Array<NewProjects> = [];
  archiveCompletedProjects: Array<NewProjects> = [];
  isCancelledArchive: boolean;
  isEditableOptionEnable: boolean;
  righttabIdentify: string; // Tab Navigator

  projectDetails: ProjectDetails = new ProjectDetails();
  isVisibleNewProject: boolean;
  loaderActivate: boolean;
  isDataAvailable: boolean;
  // tslint:disable-next-line:no-inferrable-types
  isActiveIndex: number = 0;
  // tslint:disable-next-line:no-inferrable-types
  isActiveRequestIndex: number = 0;
  // tslint:disable-next-line:no-inferrable-types
  isActiveArchiveIndex: number = 0;

  // tslint:disable-next-line:no-inferrable-types
  activeStep: number = 1;
  currentSellerId: number = null;
  latestBuyerId: number;

  // messaging section properties
  public messages: MessageModel[] = [];
  public initialSetOfMessages: Array<any> = [];
  // at initiall all the old messages are loaded from fire base and saved into this
  // tslint:disable-next-line:no-inferrable-types
  public messageToSend: string = '';

  public fileDataDisplay: Array<any> = [];
  public fileData: Array<any> = [];
  public currentUserId: number = null;
  // tslint:disable-next-line:no-inferrable-types
  public currentUserProfilePic: string = '';
  // tslint:disable-next-line:no-inferrable-types
  public recipientProfilePicNameInitials: string = '';
  // tslint:disable-next-line:no-inferrable-types
  private attachedFileType: string = '';
  public attachedFileDisplayUrl = '';
  public attachedFileDisplayName = '';
  // tslint:disable-next-line:no-inferrable-types
  public isScrollToBottom: boolean = true;
  // tslint:disable-next-line:no-inferrable-types
  public uploadingAttachment: boolean = false;
  // tslint:disable-next-line:no-inferrable-types
  public isLoadingAttachments: boolean = false;
  // tslint:disable-next-line:no-inferrable-types
  public loadingMoreMessages: boolean = false;
  // tslint:disable-next-line:no-inferrable-types
  private attachmentUrl: string = '';
  // tslint:disable-next-line:no-inferrable-types
  private messagesScrollStartIndex: number = 0;
  // tslint:disable-next-line:no-inferrable-types
  private noOfMessagesPerScroll: number = 10;
  @ViewChild('messageTextBox') messageTextBox: ElementRef;
  @ViewChild('messagesContainer') messagesContainer: ElementRef;
  @ViewChildren('selectFileCheckBox') selectFileCheckBoxs: any;
  @ViewChild('deleteFilesConfirmationModal') deleteFilesConfirmationModal: ElementRef;
  @ViewChild('closeAgreementModalWarning') closeAgreementModalWarning: ElementRef;
  @ViewChild('closeMainAgreementModalByHidden') closeMainAgreementModalByHidden: ElementRef;

  // files section properties
  public activityFiles: any[] = [];
  public selectedFileType: string = CommonConstants.FILE_TYPE_ALL;
  // tslint:disable-next-line:no-inferrable-types
  public noOfAllActivityFiles: number = 0;
  // tslint:disable-next-line:no-inferrable-types
  public loadingMoreFiles: boolean = false;
  public selectedFiles: any[] = [];
  // tslint:disable-next-line:no-inferrable-types
  public totalCount: number = 0;
  // tslint:disable-next-line:no-inferrable-types
  public imageCount: number = 0;
  // tslint:disable-next-line:no-inferrable-types
  public docCount: number = 0;
  // tslint:disable-next-line:no-inferrable-types
  public audioCount: number = 0;
  // tslint:disable-next-line:no-inferrable-types
  public videoCount: number = 0;
  // tslint:disable-next-line:no-inferrable-types
  public otherCount: number = 0;
  // tslint:disable-next-line:no-inferrable-types
  public environmentFilter: string = 'external_activities';
  // tslint:disable-next-line:no-inferrable-types
  private filesStartNo: number = 0;
  // tslint:disable-next-line:no-inferrable-types
  private noOfFilesPerLoad: number = 12;
  @ViewChild('selectAllFilesCheckBox') public selectAllFilesCheckBox: any;
  viewimageFilePath: string;
  // files section - constant data for html
  public fileTypeAll: string = CommonConstants.FILE_TYPE_ALL;
  public fileTypeImage: string = CommonConstants.FILE_TYPE_IMAGE;
  public fileTypeDoc: string = CommonConstants.FILE_TYPE_DOC;
  public fileTypeAudio: string = CommonConstants.FILE_TYPE_AUDIO;
  public fileTypeVideo: string = CommonConstants.FILE_TYPE_VIDEO;
  public fileTypeOther: string = CommonConstants.FILE_TYPE_OTHER;
  // tslint:disable-next-line:no-inferrable-types
  activeformatindex: number = 0;

  // Create Agreement
  agreementCreate: AgreementCreateObj = new AgreementCreateObj();
  // tslint:disable-next-line:no-inferrable-types
  priceOption: string = 'Fast pris';
  agreementhtmlstring: string;
  public projectId: number = null;
  agreementFiles: Array<any> = [];
  agreementFileData: Array<any> = [];
  // tslint:disable-next-line:no-inferrable-types
  tabIndentification: string = 'activeProjects';
  agreementfilename: string;
  uploadagreement: any = {};
  agreementparentId: number = null;
  uploadErrorMessage: string;
  currentSellerInformation: any = {};
  currentBuyerInformation: any = {};
  overviewDescriptionagree: string;
  latestAgreementInfo: any = {};
  attachmentBottom: boolean;
  // tslint:disable-next-line:no-inferrable-types
  generatedbodyAttachment: string = '';
  attachmentcreatedDate: Date;
  @ViewChild('activeuploadStep') activeuploadStep: NgForm;
  @ViewChild('closecreateOfferModal') closecreateOfferModal: ElementRef;
  @ViewChild('closeuploadOfferModal') closeuploadOfferModal: ElementRef;
  @ViewChild('closeChangecreateOfferModal') closeChangecreateOfferModal: ElementRef;
  @ViewChild('firstStepAdditionalAgreement') firstStepAdditionalAgreement: ElementRef;

  @ViewChild('secondStepAdditionalAgreement') secondStepAdditionalAgreement: ElementRef;
  @ViewChild('thirdStepAdditionalAgreement') thirdStepAdditionalAgreement: ElementRef;

  @ViewChild('firstStepMainAgreement') firstStepMainAgreement: ElementRef;
  activateFistStepValidation: boolean;
  activateLastStepValidation: boolean;
  activateSecondStepValidation: boolean;
  // Co Workers charts
  workerlist: Array<any> = [];
  workerInformation: any = {};
  // tslint:disable-next-line:no-inferrable-types
  public messageToSendCoWorkers: string = '';
  public messagesCoWorkers: MessageModel[] = [];
  public initialSetOfMessagesCoWorkers: Array<any> = [];

  public fileDataCoDisplay: Array<any> = [];
  public fileDataCoWorker: Array<any> = [];
  // tslint:disable-next-line:no-inferrable-types
  public recipientProfilePicNameInitialsCoWorker: string = '';
  // tslint:disable-next-line:no-inferrable-types
  private attachedFileTypeCoWorker: string = '';
  public attachedFileDisplayUrlCoWorker = '';
  public attachedFileDisplayNameCoWorker = '';
  // tslint:disable-next-line:no-inferrable-types
  public isScrollToBottomCoWorker: boolean = true;
  // tslint:disable-next-line:no-inferrable-types
  public uploadingAttachmentCoWorker: boolean = false;
  // tslint:disable-next-line:no-inferrable-types
  public isLoadingAttachmentsCoWorker: boolean = false;
  // tslint:disable-next-line:no-inferrable-types
  public loadingMoreMessagesCoWorker: boolean = false;
  // tslint:disable-next-line:no-inferrable-types
  private attachmentUrlCoWorker: string = '';
  // tslint:disable-next-line:no-inferrable-types
  private messagesScrollStartIndexCoWorker: number = 0;
  // tslint:disable-next-line:no-inferrable-types
  private noOfMessagesPerScrollCoWorker: number = 10;
  @ViewChild('messageTextBoxCoWorker') messageTextBoxCoWorker: ElementRef;
  @ViewChildren('selectFileCheckBoxCoWorker') selectFileCheckBoxsCoWorker: any;
  fileuploaderrormessage: string;
  getAllCoWorkersLatestMessageOnIntinSubscription: any;
  getAllLatestMessageOnIntinSubscription: any;


  unReadMessageCount: Array<any> = [];
  unReadMessageCoWorkerCount: Array<any> = [];
  isInitialNotification: boolean;
  isInitialNotificationCoWorker: boolean;
  isAgreedNotification: boolean;
  isAgreedNotificationCoWorker: boolean;
  isAcceptedNotification: boolean;
  isEditableCategory: boolean;
  // tslint:disable-next-line:no-inferrable-types
  displayCom: string = 'safety';
  @ViewChild('commonComponent') commonComponent;

  // Project FInal Status
  isCheckedProjectStatus: boolean;
  Selectedprojectstatus: string;
  @ViewChild('closeprojectModal') closeprojectModal: ElementRef;
  @ViewChild('openCloseprojectModal') openCloseprojectModal: ElementRef;
  @ViewChild('openModalClose') openModalClose: ElementRef;


  // Change and additional
  // tslint:disable-next-line:no-inferrable-types
  changeActiveStep: number = 1;
  changeAgreementObject: ChangeAgreementObject = new ChangeAgreementObject();
  extraServiceCategories: Array<any> = [];
  selectedextraServiceCategories: Array<any> = [];
  selectedextraservice: Array<any> = [];
  isestraerrormessage: boolean;
  worksScopeLength: number;
  isvalidation: boolean;
  internalCreatedProjectInformation: any = {};
  isQueryparams: boolean;
  isPosibleCreateAgreement: boolean;
  archiveNotification: Array<any> = [];
  displayarchiveprojectlistnames: string;
  refreshIntervalId: any;

  constructor(
    private sellerService: SellerApiService,
    private cognitoService: CognitoUtil,
    private firebaseHelperService: FirebaseHelperService,
    private route: ActivatedRoute,
    private globalEventsManager: GlobalEventsManager, private translate: TranslateService) {
    this.globalEventsManager.sendUnreadMessageArrayEmitter.subscribe((mode) => {
       this.isAgreedNotification = false;
       this.isAcceptedNotification = false;
      this.unReadMessageCount = mode;
    });

    this.globalEventsManager.sendUnreadMessageCoWorkerArrayEmitter.subscribe((mode) => {
       this.isAgreedNotificationCoWorker = false;
      this.unReadMessageCoWorkerCount = mode;
    });

    this.globalEventsManager.sendEnableEditScopeDetailsEmitter.subscribe((mode) => {
      this.isEditableOptionEnable = mode;
    });

    this.globalEventsManager.sendInternalEditedNameEmitter.subscribe((mode) => {
      if (mode != null) {
        this.acceptedProjects[this.isActiveRequestIndex]['project_internal_name'] = mode;

      }
    });

  }


  //#region  NgOnInit Section
  ngOnInit() {
    this.righttabIdentify = 'overview';
    this.changeAgreementObject.priceOption1 = 'Fast pris';
    this.changeAgreementObject.is_debited = true;
    this.agreementCreate.priceOption1 = 'Fast pris';
    this.agreementfilename = '';
    this.fileuploaderrormessage = '';
    this.uploadErrorMessage = '';
    // tslint:disable-next-line:prefer-const
    let userDetails = this.cognitoService.getCurrentUser();
    this.userFirstname = localStorage.getItem('yasoUserFirstName');
    this.loaderActivate = true;
    this.globalEventsManager.sendHeaderActivate('safetybox');
    // Query Parameter
    this.route.queryParams.subscribe(params => {
      if (params.hasOwnProperty('requesttype')) {
        if (params['requesttype'] === 'main') {
          this.tabIndentification = 'activeRequests';
        } else if (params['requesttype'] === 'archive') {
          this.tabIndentification = 'archive';
        } else {
          this.tabIndentification = 'activeProjects';
        }

        if (params['selectedtab'] === 'agreement') {
          this.righttabIdentify = 'agreement';
        } else {
          this.righttabIdentify = 'overview';
        }

        // Routing Identify
        if (params['cancellationtype'] === 'cancel') {
          this.isCancelledArchive = true;
        }

        // Project Id
        if (params['projectid']) {
          this.projectId = Number(params['projectid']);
          this.isQueryparams = true;
        }

        // Project Id
        // if (params['amp;projectid']) {
        //   this.projectId = Number(params['amp;projectid']);
        //   this.isQueryparams = true;
        // }
      }
    });

    //  get current user id and  current user profile picture
    if (userDetails.username != null) {
      // this.getALlUnreadMessagesProjects(userDetails.username);
      this.sellerService.getProfileDetails(userDetails.username).subscribe(res => {
        if (res != null) {
          this.currentSellerInformation = res;
          this.currentUserId = res.user_id;
          this.currentSellerId = res.seller_id;
          // tslint:disable-next-line:max-line-length
          (res.image_url === null) ? this.currentUserProfilePic = '../assets/images/profileImg.png' : this.currentUserProfilePic = res.image_url;
          this.agreementCreate.sellername = res.first_name;
          this.agreementCreate.sellerorganization = res.company_name;
          this.agreementCreate.selleremail = res.seller_email;
          this.agreementCreate.sellerphonenumber = res.contact_no;
          this.agreementCreate.sellerAddress = res.address;
          this.agreementCreate.sellerregistredNumber = res.company_registration_no;
          this.agreementCreate.sellerregistredforTax = 'Yes';

          this.changeAgreementObject.sellername = res.first_name;
          this.changeAgreementObject.sellerorganization = res.company_name;
          this.changeAgreementObject.selleremail = res.seller_email;
          this.changeAgreementObject.sellerphonenumber = res.contact_no;
          this.changeAgreementObject.sellerAddress = res.address;
          this.changeAgreementObject.sellerregistredNumber = res.company_registration_no;
          this.changeAgreementObject.sellerregistredforTax = 'Yes';
          // Agreement for Signicat Verification
          if (environment.backendapi === 'https://api.yosso.se') {
            this.gettoCheckMainServiceAgreemntCreate(res.company_registration_no);
          } else {
            this.isPosibleCreateAgreement = true;
          }

          // Archive Notification
          this.getNotificationArchivemoverecntly(this.currentSellerId);
        }
      }, err => {
        console.log(err);
      });

      // Extra Categories
      this.getExtraServiceCategories();
    }


    this.sellerService.getAllAgreedProjects(userDetails.username).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.agreedProjects = res;
        this.isVisibleNewProject = true;
        if (this.agreedProjects.length > 0) {
          this.isDataAvailable = true;
          if (this.agreedProjects[0].project_id && this.agreedProjects[0].project_id != null) {
            this.isInitialNotification = true;
            this.isInitialNotificationCoWorker = true;
            if (!this.isQueryparams) {
              this.callProjectDetails(this.agreedProjects[0].project_id,
                this.agreedProjects[0].buyer_id,
                this.agreedProjects[0].buyer_first_name,
                this.agreedProjects[0].buyer_last_name, 0);
            } else {
              if (this.tabIndentification === 'activeProjects') {
                this.agreedProjects.forEach((item, index) => {
                  if (item.project_id === this.projectId) {
                    this.callProjectDetails(item.project_id,
                      item.buyer_id,
                      item.buyer_first_name,
                      item.buyer_last_name, index);
                  }
                });
              }
            }
          }
        }
      }
    }, err => {
      console.log(err);
    });

    // get the Accepted Projects
    this.sellerService.getacceptedProjects(userDetails.username).subscribe(res => {
      if (res != null) {
        this.acceptedProjects = res;
        if (this.acceptedProjects.length > 0) {
          if (this.isQueryparams) {
            if (this.tabIndentification === 'activeRequests') {
              this.acceptedProjects.forEach((item, index) => {
                if (item.project_id === this.projectId) {
                  this.isDataAvailable = true;
                  this.callProjectDetails(item.project_id,
                    item.buyer_id,
                    item.buyer_first_name,
                    item.buyer_last_name, index);
                }
              });
            }
          }
          // this.callProjectDetails(this.acceptedProjects[0].project_id);
          this.globalEventsManager.sendActiveRequestProjectIds(this.acceptedProjects.map(a => a.project_id));
        }
      }
    }, err => {
      console.log(err);
    });

    // Get the Archive Projects and Completed Projects
    this.getArchiveProjectLists();

  }

  ngAfterViewInit() {

  }

    // Check Offere Create or Not for Main Agreement
  gettoCheckMainServiceAgreemntCreate(company_registration_no) {
    this.sellerService.checkProductionCreateOffer(company_registration_no).subscribe(res => {
      if (res != null) {
        if (res.includes('The system is not available')) {
          this.isPosibleCreateAgreement = false;
        } else {
          this.isPosibleCreateAgreement = true;
        }
      }
    }, err => {
      console.log(err);
    });
  }


  // Grouping IDs For Notiifcation in the Header Section.... can be temperary..
  group(arr, key) {
    return [...arr.reduce((acc, o) =>
      acc.set(o[key], (acc.get(o[key]) || []).concat(o))
      , new Map).values()];
  }

  // Get Archive Projects List
  getArchiveProjectLists() {
    // tslint:disable-next-line:prefer-const
    let userDetails = this.cognitoService.getCurrentUser();
    if (userDetails.username != null) {
      this.sellerService.getArchiveProjectList(userDetails.username).subscribe(res => {
        if (res != null) {
          this.archiveProjects = res.rejected_projects;
          this.completedProjects = res.completed_projects;
          if (this.isCancelledArchive) {
            this.archiveCompletedProjects = this.archiveProjects;
          } else {
            this.archiveCompletedProjects = this.completedProjects;
          }
          if (this.tabIndentification === 'archive') {
            this.archiveCompletedProjects.forEach((item, index) => {
              if (item.project_id === this.projectId) {
                this.callProjectDetails(item.project_id,
                  item.buyer_id,
                  item.buyer_first_name,
                  item.buyer_last_name, index);
              }
            });
          }
        }
      }, err => {
        console.log(err);
      });
    }
  }


    // get the Archive Move notification
  getNotificationArchivemoverecntly(sellerid) {
    this.sellerService.get_project_Archive_Notification(sellerid).subscribe(res => {
      if (res != null || res.length > 0) {
        this.archiveNotification = res;
        this.displayarchiveprojectlistnames = this.archiveNotification.map((item) => item.project_name).join(', ');
      }
    }, err => {
      console.log(err);
    });
  }

  // Update the Archive Notifications
  updateArchiveNotification() {
    if (this.archiveNotification.length > 0) {
      const projectIds = this.archiveNotification.map((item) => item.project_id).join(',');
      this.sellerService.updateProjectArchiveNotificationstatus(projectIds).subscribe(res => {
        if (res != null || res.length > 0) {
          this.archiveNotification = [];
        }
      }, err => {
        console.log(err);
      });
    }
  }

  //#endregion

  //#region Start the Initial Load Functions

  tabredirectionValue(value) {
    if (this.isEditableOptionEnable) {
      this.righttabIdentify =  'overview';
      this.globalEventsManager.sendopenConfirmationModal(true);
      return;
    }
    this.righttabIdentify = value;

  }

  // Update Unread Messages
  loadUnreadMessageUpdate(value) {
    if (this.isEditableOptionEnable) {
      this.righttabIdentify =  'overview';
      this.globalEventsManager.sendopenConfirmationModal(true);
      return;
    }

    this.righttabIdentify =  value;
    if (this.isInitialNotification) {
      this.isInitialNotification = false;
      this.firebaseHelperService.updateExternalMessageLog(this.projectId, this.currentSellerId, this.currentUserId);
      // tslint:disable-next-line:prefer-const
      let obj = this.unReadMessageCount.find(v => v.projectid === this.projectId);
      if (obj) {
        this.unReadMessageCount.find(v => v.projectid === this.projectId).count = 0;
      }
      this.globalEventsManager.sendMessageReadArray(this.unReadMessageCount);
    } else {
      if (this.righttabIdentify === 'message') {
        this.isInitialNotification = false;
        this.firebaseHelperService.updateExternalMessageLog(this.projectId, this.currentSellerId, this.currentUserId);
        // tslint:disable-next-line:prefer-const
        let obj = this.unReadMessageCount.find(v => v.projectid === this.projectId);
        if (obj) {
          this.unReadMessageCount.find(v => v.projectid === this.projectId).count = 0;
        }
        this.globalEventsManager.sendMessageReadArray(this.unReadMessageCount);
      }
    }
  }

  // Update Unread Messages
  loadUnreadMessageUpdateCoWorker(value) {
    if (this.isEditableOptionEnable) {
      this.globalEventsManager.sendopenConfirmationModal(true);
      return;
    }

    this.righttabIdentify =  value;
    if (this.isInitialNotificationCoWorker) {
      this.isInitialNotificationCoWorker = false;
      this.firebaseHelperService.updateExternalMessageCoworkerLog(this.projectId, this.currentSellerId, this.currentUserId);
      // tslint:disable-next-line:prefer-const
      let obj = this.unReadMessageCoWorkerCount.find(v => v.projectid === this.projectId);
      if (obj) {
        this.unReadMessageCoWorkerCount.find(v => v.projectid === this.projectId).count = 0;
      }
      this.globalEventsManager.sendMessageArrayCoWorker(this.unReadMessageCoWorkerCount);
    } else {
      if (this.righttabIdentify === 'workers') {
        this.isInitialNotificationCoWorker = false;
        this.firebaseHelperService.updateExternalMessageCoworkerLog(this.projectId, this.currentSellerId, this.currentUserId);
        // tslint:disable-next-line:prefer-const
        let obj = this.unReadMessageCoWorkerCount.find(v => v.projectid === this.projectId);
        if (obj) {
          this.unReadMessageCoWorkerCount.find(v => v.projectid === this.projectId).count = 0;
        }
        this.globalEventsManager.sendMessageArrayCoWorker(this.unReadMessageCoWorkerCount);
      }
    }
  }


  // Call the Project details
  callProjectDetails(projectid: number, buyerId: number, buyerfirstname: string, buyerlastname: string, index: number): void {
    if (this.isEditableOptionEnable) {
      this.globalEventsManager.sendopenConfirmationModal(true);
      return;
    }

    if (this.getAllLatestMessageOnIntinSubscription) {
      this.getAllLatestMessageOnIntinSubscription.unsubscribe();
    }

    if (this.getAllCoWorkersLatestMessageOnIntinSubscription) {
      this.getAllCoWorkersLatestMessageOnIntinSubscription.unsubscribe();
    }

    this.loaderActivate = true;
    if (this.tabIndentification === 'activeProjects') {
      this.isEditableCategory = false;
      this.isActiveIndex = index;
    } else if (this.tabIndentification === 'activeRequests') {
      this.isEditableCategory = true;
      this.isActiveRequestIndex = index;
    } else if (this.tabIndentification === 'archive') {
      this.isActiveArchiveIndex = index;
      this.isEditableCategory = false;
    }
    this.projectId = projectid;
    this.latestBuyerId = buyerId;
    if (buyerlastname === null) {
      buyerlastname = '';
    }
    (buyerId > 0) ? this.buyerDisplayName = buyerfirstname + ' ' + buyerlastname : this.buyerDisplayName = '';
    this.selectedFileType = CommonConstants.FILE_TYPE_ALL;
    // Call the Co Worker's Information
    this.getAllWorkersList(projectid);

    if (buyerId > 0) {
      this.getBuyerInformation(buyerId);
    }

    if (buyerId === null || buyerId === 0) {
      this.getInternallyCreatedBuyerInformation(this.projectId);
    }

    // check Seller Id Null ---
    // if (this.currentSellerId != null) {

    // }

    this.sellerService.getProjectInformationByProjectId(projectid.toString(), this.currentSellerId).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.projectDetails = res;
        this.projectDetails.buyer_id = buyerId;
        // Set the Dipslay Brief in agreement section
        this.agreementCreate.buyerworkdescription = this.projectDetails.overview;

        // Calling Projects Files
        this.getAgreementFilePath(this.projectId, this.currentSellerId);

        // generate message recipient profile pic name initials
        // tslint:disable-next-line:max-line-length
        (this.projectDetails.buyer_id > 0) ? this.recipientProfilePicNameInitials = buyerfirstname.split('')[0] + buyerlastname.split('')[0] : this.recipientProfilePicNameInitials = 'IC';
        // Remove Previous messages from projects
        this.messages = [];
        this.initialSetOfMessages = [];

        this.messagesCoWorkers = [];
        this.initialSetOfMessagesCoWorkers = [];
        this.messagesScrollStartIndex = 0;
        this.messagesScrollStartIndexCoWorker = 0;
        // this.isScrollToBottom = true;
        // this.isScrollToBottomCoWorker = true;


        // get all messages initially
        // tslint:disable-next-line:prefer-const
        let getAllMessagesOnIntinSubscription = this.firebaseHelperService.getAllMessages(
          this.projectDetails.project_id, this.currentSellerId, this.projectDetails.buyer_id).subscribe(allMessages => {

            // when no messages are available
            if (allMessages.length === 0) {
              this.messages = [];
              this.initialSetOfMessages = [];
            } else {

              // convert data into message model and attach push key as id
              allMessages.forEach(element => {
                let messageModel = element.payload.val();
                if (messageModel) {
                  messageModel = <MessageModel>messageModel;
                  messageModel['id'] = element.key;
                  this.initialSetOfMessages.push(messageModel);
                }
              });
              // tslint:disable-next-line:max-line-length
              // after getting messages initially unsubcribe all messages watching (or else this method will get all the messages everytime database update)
              getAllMessagesOnIntinSubscription.unsubscribe();

              // from the initial set of messages extract set of messages to display on initial
              this.messagesScrollStartIndex = this.initialSetOfMessages.length - 1;
              this.getMessagesToDisplay();

            }

            // open get latest message subscription
            this.getLatestMessages();
            this.isScrollToBottom = true;

          });

        // Co Worker's Message Load  By Project ID
        // get all messages initially
        // tslint:disable-next-line:prefer-const
        let getAllCoWorkersMessagesOnIntinSubscription = this.firebaseHelperService.getAllCoWorkerMessages(
          this.projectDetails.project_id, this.currentSellerId).subscribe(allMessages => {

            // when no messages are available
            if (allMessages.length === 0) {
              this.messagesCoWorkers = [];
              this.initialSetOfMessagesCoWorkers = [];
            } else {

              // convert data into message model and attach push key as id
              allMessages.forEach(element => {
                let messageModel = element.payload.val();
                if (messageModel) {
                  messageModel = <MessageModel>messageModel;
                  messageModel['id'] = element.key;
                  this.initialSetOfMessagesCoWorkers.push(messageModel);
                }
              });
              // tslint:disable-next-line:max-line-length
              // after getting messages initially unsubcribe all messages watching (or else this method will get all the messages everytime database update)
              getAllCoWorkersMessagesOnIntinSubscription.unsubscribe();

              // from the initial set of messages extract set of messages to display on initial
              this.messagesScrollStartIndexCoWorker = this.initialSetOfMessagesCoWorkers.length - 1;
              this.getMessagesCoWorkersToDisplay();

            }

            // open get latest message subscription
            this.getLatestMessagesCoWorkers();
            this.isScrollToBottomCoWorker = true;

          });

        // load Files tab data
        this.environmentFilter = 'external_activities';
        this.activeformatindex = 0;
        this.fileTypeSelected(CommonConstants.FILE_TYPE_ALL);

        if (!this.isInitialNotification && this.righttabIdentify === 'message') {
          this.isInitialNotification = false;
          this.firebaseHelperService.updateExternalMessageLog(this.projectId, this.currentSellerId, this.currentUserId);
          this.unReadMessageCount.find(v => v.projectid === this.projectId).count = 0;
          this.globalEventsManager.sendMessageReadArray(this.unReadMessageCount);
        }

        if (!this.isInitialNotificationCoWorker && this.righttabIdentify === 'workers') {
          this.isInitialNotificationCoWorker = false;
          this.firebaseHelperService.updateExternalMessageCoworkerLog(this.projectId, this.currentSellerId, this.currentUserId);
          this.unReadMessageCoWorkerCount.find(v => v.projectid === this.projectId).count = 0;
          this.globalEventsManager.sendMessageArrayCoWorker(this.unReadMessageCoWorkerCount);
        }

      }
    }, err => {
      console.log(err);
    });
  }



  // get latest messages - and keep this subscription open to get only latest/new message when database is update
  // attach latest message into messages array
  public getLatestMessages() {
    this.loadingMoreMessages = true;

    this.getAllLatestMessageOnIntinSubscription = this.firebaseHelperService.getLatestMessages(this.projectDetails.project_id,
      this.currentSellerId, this.projectDetails.buyer_id)
      .subscribe(latestMessages => {
        // if latest message is not the messages array, add it into array
        if (latestMessages && latestMessages.length > 0) {
          // tslint:disable-next-line:prefer-const
          let messagearray: Array<any> = [];
          if (this.messages.length > 10) {
            messagearray = this.messages.slice(Math.max(this.messages.length - 10, 1));
          } else {
            messagearray = this.messages;
          }
          // tslint:disable-next-line:prefer-const
          let latestMessage = latestMessages[0].payload.val();
          if (latestMessage && (this.messages.length === 0 || messagearray.every(m => m.id !== latestMessages[0].key))) {
            // tslint:disable-next-line:prefer-const
            let messageModel = <MessageModel>latestMessage;
            messageModel.id = latestMessages[0].key;
            this.messages.push(messageModel);

          }
        }
        this.loadingMoreMessages = false;
      });
  }


  // Display the Unread Messsage Count
  getTodisplayMeesageCount(projectid) {
    // tslint:disable-next-line:prefer-const
    let count = 0;
    // tslint:disable-next-line:prefer-const
    let object = this.unReadMessageCount.filter(
      item => item.projectid === projectid);
    if (object.length > 0) {
      count = object[0].count;
      if (count > 0) {
        this.isAgreedNotification = true;
      }
    }
    return count;
  }

  getTodisplayActiverequestMeesageCount(projectid) {
    // tslint:disable-next-line:prefer-const
    let count = 0;
    // tslint:disable-next-line:prefer-const
    let object = this.unReadMessageCount.filter(item => item.projectid === projectid);
    if (object.length > 0) {
      count = object[0].count;
      if (count > 0) {
        this.isAcceptedNotification = true;
      }
    }
    return count;
  }

  // Display the Unread Messsage Count
  getTodisplayMeesageCountCoworker(projectid) {
    // tslint:disable-next-line:prefer-const
    let count = 0;
    // tslint:disable-next-line:prefer-const
    let object = this.unReadMessageCoWorkerCount.filter(
      item => item.projectid === projectid);
    if (object.length > 0) {
      count = object[0].count;
      if (count > 0) {
        this.isAgreedNotificationCoWorker = true;
      }
    }
    return count;
  }




  // Get Latest Messages from Co Workers

  public getLatestMessagesCoWorkers() {
    this.loadingMoreMessagesCoWorker = true;

    this.getAllCoWorkersLatestMessageOnIntinSubscription =
    this.firebaseHelperService.getLatestCoWorkerMessages(this.projectDetails.project_id,
      this.currentSellerId)
      .subscribe(latestMessages => {
        // if latest message is not the messages array, add it into array
        if (latestMessages && latestMessages.length > 0) {
          // tslint:disable-next-line:prefer-const
          let messagearray: Array<any> = [];
          if (this.messagesCoWorkers.length > 10) {
            messagearray = this.messagesCoWorkers.slice(Math.max(this.messagesCoWorkers.length - 10, 1));
          } else {
            messagearray = this.messagesCoWorkers;
          }
          // tslint:disable-next-line:prefer-const
          let latestMessage = latestMessages[0].payload.val();
          // tslint:disable-next-line:max-line-length
          if (latestMessage && (this.messagesCoWorkers.length === 0 || messagearray.every(m => m.id !== latestMessages[0].key))) {
            // tslint:disable-next-line:prefer-const
            let messageModel = <MessageModel>latestMessage;
            messageModel.id = latestMessages[0].key;
            this.messagesCoWorkers.push(messageModel);
          }
        }
        this.loadingMoreMessagesCoWorker = false;
      });
  }

  // Identify the Tab Change Left Side
  callTabIdentify(tabvalue): void {
    if (this.isEditableOptionEnable) {
      this.globalEventsManager.sendopenConfirmationModal(true);
      return;
    }
    switch (tabvalue) {
      case 'activeProjects':
        this.tabIndentification = 'activeProjects';
        this.isEditableCategory = false;
        this.isVisibleNewProject = true;
        if (this.agreedProjects.length > 0) {
          this.isDataAvailable = true;
          this.callProjectDetails(this.agreedProjects[0].project_id, this.agreedProjects[0].buyer_id,
            this.agreedProjects[0].buyer_first_name,
            this.agreedProjects[0].buyer_last_name, 0);
        } else {
          this.isDataAvailable = false;
        }
        break;
      case 'activeRequests':
        this.tabIndentification = 'activeRequests';
        this.isEditableCategory = true;
        this.isVisibleNewProject = false;
        if (this.acceptedProjects.length > 0) {
          this.isDataAvailable = true;
          this.callProjectDetails(this.acceptedProjects[0].project_id, this.acceptedProjects[0].buyer_id,
            this.acceptedProjects[0].buyer_first_name,
            this.acceptedProjects[0].buyer_last_name, 0);
        } else {
          this.isDataAvailable = false;
        }
        break;
      case 'archive':
        this.isVisibleNewProject = false;
        this.isEditableCategory = false;
        this.tabIndentification = 'archive';
        if (this.archiveCompletedProjects.length > 0) {
          this.isDataAvailable = true;
          this.callProjectDetails(this.archiveCompletedProjects[0].project_id,
            this.archiveCompletedProjects[0].buyer_id,
            this.archiveCompletedProjects[0].buyer_first_name,
            this.archiveCompletedProjects[0].buyer_last_name, 0);
        } else {
          this.isDataAvailable = false;
        }
        break;
      default:
    }
  }

  callArchiveCompletedChanges(text): void {
    if (text === 'archive') {
      this.isDataAvailable = true;
      this.archiveCompletedProjects = this.archiveProjects;
    } else {
      this.isDataAvailable = true;
      this.archiveCompletedProjects = this.completedProjects;
    }

  }


  /** Temperary Code her */

  // acceptProjects(projectid, isaccepted): void {
  //   // tslint:disable-next-line:prefer-const
  //   let userDetails = this.cognitoService.getCurrentUser();
  //   this.sellerService.acceptRejectProjectRequest(userDetails.username, projectid, isaccepted).subscribe(res => {
  //     if (res != null) {
  //       console.log(res);
  //     }
  //   }, err => {
  //     console.log(err);
  //   });
  // }

  declineProjects(): void {

  }

  //#endregion

  //#region Message To client Section Start
  // =================================================== START SECTION MESSAGING ===================================================

  // attach file by upload button click
  public attachFileByInputClick(event) {
    this.fileData = [];
    if (event.target.files && event.target.files[0]) {
      for (let index = 0; index < event.target.files.length; index++) {
        this.attachFile(event.target.files[index]);
      }
    }
  }

  // attach file by drop file into drop zone
  public attachFileByDrop(event: UploadEvent) {
    this.fileData = [];
    // tslint:disable-next-line:prefer-const
    // let droppedFile = event.files[0];
    if (event.files && event.files[0]) {
      for (let index = 0; index < event.files.length; index++) {
        // this.attachFile(event.files[index]);
        const fileEntry = event.files[index].fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          if (file) {
            this.attachFile(file);
          }
        });
      }
    }

  }

  // attaching the file that uploaded by drag drop and by button click
  private attachFile(file: File) {
    this.attachedFileDisplayName = '';
    // set attachment file type and validate file size according to file type
    if (!this.setFileTypeAndValidate(file.type, file.size, file.name, 'External')) {
      this.fileData = [];
      return;
    }

    this.fileData.push({ file: file, type: this.attachedFileType });

    // to display attached file
    this.attachedFileDisplayName = file.name;

    if (this.attachedFileType === CommonConstants.FILE_TYPE_IMAGE) {
      // tslint:disable-next-line:prefer-const
      let reader = new FileReader();
      reader.onload = (event: any) => {
        this.attachedFileDisplayUrl = event.target.result;
        this.fileDataDisplay.push({
          name: this.attachedFileDisplayName,
          url: this.attachedFileDisplayUrl
        });
      };
      reader.readAsDataURL(file);
    } else {
      this.fileDataDisplay.push({
        name: this.attachedFileDisplayName,
        url: this.attachedFileDisplayUrl
      });
    }
  }


  // set attachment file type and validate file size according to file type
  private setFileTypeAndValidate(fileType: string, sizeInBytes: number, name: string, activitytype: string) {
    this.fileuploaderrormessage = '';
    let mainFileType = fileType.split('/')[0];

    // to determine if this is a document file or not
    if (mainFileType === 'application') {
      // tslint:disable-next-line:prefer-const
      let extension = name.split('.').splice(-1)[0].toLocaleLowerCase();
      mainFileType = this.sellerService.getMainFileType(extension);
    } else if (mainFileType === 'text') {
      // tslint:disable-next-line:prefer-const
      let extension = name.split('.').splice(-1)[0].toLocaleLowerCase();
      mainFileType = this.sellerService.getMainFileType(extension);
    } else if (mainFileType === '') {
      // tslint:disable-next-line:prefer-const
      let extension = name.split('.').splice(-1)[0].toLocaleLowerCase();
      mainFileType = this.sellerService.getMainFileType(extension);
      if (mainFileType == null) {
        if (extension === 'mp3' || extension === 'ogg' || extension === 'wav'
          || extension === 'webm' || extension === 'mmf' || extension === 'm4p' || extension === 'msv') {
          mainFileType = 'audio';
        } else if (extension === 'flv'
          || extension === 'mov' || extension === 'mp4' || extension === 'avi' || extension === 'mpeg' || extension === 'wmv') {
          mainFileType = 'video';
        } else {
          // this.fileuploaderrormessage = 'File type isnot supported';
          this.translate.get('Profile.Filetypesupported').subscribe(res => {
            this.fileuploaderrormessage = res;
          });
          return false;
        }
      }
      // if (extension === 'docx' || extension === 'pdf'
      //   || extension === 'doc' || extension === 'txt' || extension === 'odt' || extension === 'csv' ||
      //   extension === 'xlsx' || extension === 'tex') {
      //   mainFileType = 'doc';
      // } else
    }

    switch (mainFileType) {

      case 'image':
        if (sizeInBytes > 3000000) { // image validation cannot exceed 2mb
          // this.fileuploaderrormessage = 'Maximum image size cannot exceed 2mb';
          this.translate.get('SafetyBox.FileSizeErrorMessage1').subscribe(res => {
            this.fileuploaderrormessage = res;
          });
          return false;
        } else {
          this.attachedFileType = CommonConstants.FILE_TYPE_IMAGE;
          return true;
        }

      case 'doc':
        if (sizeInBytes > 50000000) {// doc validation cannot exceed 50mb
          // this.fileuploaderrormessage = 'Maximum document size cannot exceed 50mb';
          this.translate.get('SafetyBox.FileSizeErrorMessage').subscribe(res => {
            this.fileuploaderrormessage = res;
          });
          return false;
        } else {
          this.attachedFileType = CommonConstants.FILE_TYPE_DOC;
          (activitytype === 'External') ? this.attachedFileDisplayUrl = '../assets/images/doc.png' :
            this.attachedFileDisplayUrlCoWorker = '../assets/images/doc.png';

          return true;
        }

      case 'pdf':
        if (sizeInBytes > 50000000) {// doc validation cannot exceed 50mb
          // this.fileuploaderrormessage = 'Maximum document size cannot exceed 50mb';
          this.translate.get('SafetyBox.FileSizeErrorMessage').subscribe(res => {
            this.fileuploaderrormessage = res;
          });
          return false;
        } else {
          this.attachedFileType = CommonConstants.FILE_TYPE_PDF;
          (activitytype === 'External') ? this.attachedFileDisplayUrl = '../assets/images/pdf-icon.png' :
            this.attachedFileDisplayUrlCoWorker = '../assets/images/pdf-icon.png';

          return true;
        }

      case 'key':
        if (sizeInBytes > 50000000) {// doc validation cannot exceed 50mb
          // this.fileuploaderrormessage = 'Maximum document size cannot exceed 50mb';
          this.translate.get('SafetyBox.FileSizeErrorMessage').subscribe(res => {
            this.fileuploaderrormessage = res;
          });
          return false;
        } else {
          this.attachedFileType = CommonConstants.FILE_TYPE_KEY;
          (activitytype === 'External') ? this.attachedFileDisplayUrl = '../assets/images/key-icon.png' :
            this.attachedFileDisplayUrlCoWorker = '../assets/images/key-icon.png';

          return true;
        }

      case 'numbers':
        if (sizeInBytes > 50000000) {// doc validation cannot exceed 50mb
         // this.fileuploaderrormessage = 'Maximum document size cannot exceed 50mb';
         this.translate.get('SafetyBox.FileSizeErrorMessage').subscribe(res => {
          this.fileuploaderrormessage = res;
        });
          return false;
        } else {
          this.attachedFileType = CommonConstants.FILE_TYPE_NUMBERS;
          (activitytype === 'External') ? this.attachedFileDisplayUrl = '../assets/images/numbers-icon.png' :
            this.attachedFileDisplayUrlCoWorker = '../assets/images/numbers-icon.png';

          return true;
        }

      case 'pages':
        if (sizeInBytes > 50000000) {// doc validation cannot exceed 50mb
         // this.fileuploaderrormessage = 'Maximum document size cannot exceed 50mb';
         this.translate.get('SafetyBox.FileSizeErrorMessage').subscribe(res => {
          this.fileuploaderrormessage = res;
        });
          return false;
        } else {
          this.attachedFileType = CommonConstants.FILE_TYPE_PAGES;
          (activitytype === 'External') ? this.attachedFileDisplayUrl = '../assets/images/pages-icon.png' :
            this.attachedFileDisplayUrlCoWorker = '../assets/images/pages-icon.png';

          return true;
        }

      case 'ppt':
        if (sizeInBytes > 50000000) {// doc validation cannot exceed 50mb
          // this.fileuploaderrormessage = 'Maximum document size cannot exceed 50mb';
          this.translate.get('SafetyBox.FileSizeErrorMessage').subscribe(res => {
            this.fileuploaderrormessage = res;
          });
          return false;
        } else {
          this.attachedFileType = CommonConstants.FILE_TYPE_PPT;
          (activitytype === 'External') ? this.attachedFileDisplayUrl = '../assets/images/ppt-icon.png' :
            this.attachedFileDisplayUrlCoWorker = '../assets/images/ppt-icon.png';

          return true;
        }

      case 'txt':
        if (sizeInBytes > 50000000) {// doc validation cannot exceed 50mb
          // this.fileuploaderrormessage = 'Maximum document size cannot exceed 50mb';
          this.translate.get('SafetyBox.FileSizeErrorMessage').subscribe(res => {
            this.fileuploaderrormessage = res;
          });
          return false;
        } else {
          this.attachedFileType = CommonConstants.FILE_TYPE_TXT;
          (activitytype === 'External') ? this.attachedFileDisplayUrl = '../assets/images/text-icon.png' :
            this.attachedFileDisplayUrlCoWorker = '../assets/images/text-icon.png';

          return true;
        }

      case 'excel':
        if (sizeInBytes > 50000000) {// doc validation cannot exceed 50mb
          // this.fileuploaderrormessage = 'Maximum document size cannot exceed 50mb';
          this.translate.get('SafetyBox.FileSizeErrorMessage').subscribe(res => {
            this.fileuploaderrormessage = res;
          });
          return false;
        } else {
          this.attachedFileType = CommonConstants.FILE_TYPE_EXCEL;
          (activitytype === 'External') ? this.attachedFileDisplayUrl = '../assets/images/excel.png' :
            this.attachedFileDisplayUrlCoWorker = '../assets/images/excel.png';

          return true;
        }

      case 'audio':
        if (sizeInBytes > 50000000) {  // audio validation cannot exceed 50mb
          // this.fileuploaderrormessage = 'Maximum audio size cannot exceed 50mb';
          this.translate.get('SafetyBox.FileSizeErrorMessage').subscribe(res => {
            this.fileuploaderrormessage = res;
          });
          return false;
        } else {
          (activitytype === 'External') ? this.attachedFileDisplayUrl = '../assets/images/audio.png' :
            this.attachedFileDisplayUrlCoWorker = '../assets/images/audio.png';
          this.attachedFileType = CommonConstants.FILE_TYPE_AUDIO;
          return true;
        }

      case 'video':
        if (sizeInBytes > 50000000) { // video validation cannot exceed 50mb
         // this.fileuploaderrormessage = 'Maximum video size cannot exceed 50mb';
         this.translate.get('SafetyBox.FileSizeErrorMessage').subscribe(res => {
          this.fileuploaderrormessage = res;
        });
          return false;
        } else {
          (activitytype === 'External') ? this.attachedFileDisplayUrl = '../assets/images/video.png' :
            this.attachedFileDisplayUrlCoWorker = '../assets/images/video.png';
          // this.attachedFileDisplayUrl = '../assets/images/video.png';
          this.attachedFileType = CommonConstants.FILE_TYPE_VIDEO;
          return true;
        }


      default:
        if (sizeInBytes > 50000000) { // other file types validation cannot exceed 50mb
         // this.fileuploaderrormessage = 'Maximum file size cannot exceed 50mb';
         this.translate.get('SafetyBox.FileSizeErrorMessage').subscribe(res => {
          this.fileuploaderrormessage = res;
        });
          return false;
        } else {
          this.attachedFileType = CommonConstants.FILE_TYPE_OTHER;
          // this.attachedFileDisplayUrl = '../assets/images/excel.png';
          (activitytype === 'External') ? this.attachedFileDisplayUrl = '../assets/images/doc.png' :
            this.attachedFileDisplayUrlCoWorker = '../assets/images/doc.png';
          return true;
        }

    }

  }


  // remove attachment
  public removeAttachedFile() {
    this.attachmentUrl = '';
    this.attachedFileDisplayUrl = '';
    this.attachedFileDisplayName = '';
    this.attachedFileType = '';
    this.fileDataCoWorker = [];
    this.fileuploaderrormessage = '';
    this.fileDataDisplay = [];
    this.fileData = [];
  }

  // Remove Uploaded Files
  removeAttachedFileUpload(item: any, ind: number): void {
    if (this.fileDataDisplay.length > ind) {
      this.fileDataDisplay.splice(ind, 1);
      this.fileData.forEach((element, index) => {
        if (element.file.name === item.name) {
          this.fileData.splice(index, 1);
        }
      });
    }
  }


  // upload attached file into s3 bucket
  public uploadAttachedFile() {
    if (!this.fileData || this.fileData.length <= 0) {
      return;
    }
    let filename = '';
    let link = '';
    this.fileData.forEach((element, index) => {
      this.uploadingAttachment = true;
      this.attachedFileType = element.type;
      filename = element.file.name;
      // call file upload
      this.sellerService.uploadAttachedFile(element.file, this.projectDetails.project_id, this.currentUserId,
        this.attachedFileType, CommonConstants.ACTIVITY_TYPE_EXTERNAL, true).subscribe(res => {
          if (res !== 'No file part') {
            this.attachmentUrl = res.activity_url;
            // send message
            // tslint:disable-next-line:prefer-const
            let newMessage = new MessageModel(this.currentUserId,
              this.projectDetails.buyer_user_id, '',
              this.attachmentUrl, res.file_type, new Date().toUTCString(), 1, filename);
            this.firebaseHelperService.sendMessage(this.projectDetails.project_id,
              this.currentSellerId, this.projectDetails.buyer_id, newMessage);

            if (this.tabIndentification === 'activeProjects') {
              link = environment.buyerendlink +
                '/buyer/safetybox?requestto=safetybox&requesttype=externalpro&projectid='
                + this.projectDetails.project_id + '&sellerid=' + this.currentSellerId;
            } else {
              link = environment.buyerendlink +
                '/buyer/safetybox?requestto=safetybox&requesttype=externalreq&projectid='
                + this.projectDetails.project_id + '&sellerid=' + this.currentSellerId;
            }
            // call Push notification
            this.sendPushNotification(this.projectDetails.project_id,
              this.currentUserId, this.projectDetails.buyer_user_id, this.getpushnotificationfiletype(res.file_type), link);

            // call Push notification IOS
            this.sendPushNotification_ios(this.projectDetails.project_id,
              this.currentUserId, this.projectDetails.buyer_user_id, this.getpushnotificationfiletype(res.file_type), link);

            // clear message typing text box and attachment details
            // this.messageToSend = '';
            this.uploadingAttachment = false;
            this.removeAttachedFile();
          }
        }, err => {
          console.log(err);
          this.uploadingAttachment = false;
        });
      if (this.fileData.length - 1 === index) {
        this.removeAttachedFile();
        this.isScrollToBottom = true;
      }
    });

  }



  // upload attachments, send message and clear message box
  public sendMessageBtnClicked() {
    // if attachment is available, upload it to s3 bucket
    if (this.fileData.length > 0) {
      this.uploadAttachedFile();
    } else {
      if (this.messageToSend) {
        this.messageToSend = this.messageToSend.substring(0, this.messageToSend.length - 1);
        if (this.messageToSend) {
          this.sendMessage();
        }
      } else {
        this.messageToSend = '';
      }
    }

  }

  // Upload Attachments, Send Message for Enter Functions
  public sendEnterFunctionSendMessageBtn($event) {
    this.sendMessageBtnClicked();
  }

  // send message - save message data into firebase database
  private sendMessage() {
    // tslint:disable-next-line:prefer-const
    let link = '';
    // send message
    // tslint:disable-next-line:prefer-const
    let newMessage = new MessageModel(this.currentUserId,
      this.projectDetails.buyer_user_id, this.messageToSend,
      this.attachmentUrl, this.attachedFileType, new Date().toUTCString(), 1, '');
    this.firebaseHelperService.sendMessage(this.projectDetails.project_id,
      this.currentSellerId, this.currentUserId, newMessage);
    if (this.tabIndentification === 'activeProjects') {
      link = environment.buyerendlink +
        '/buyer/safetybox?requestto=safetybox&requesttype=externalpro&projectid='
        + this.projectDetails.project_id + '&sellerid=' + this.currentSellerId;
    } else {
      link = environment.buyerendlink +
        '/buyer/safetybox?requestto=safetybox&requesttype=externalreq&projectid='
        + this.projectDetails.project_id + '&sellerid=' + this.currentSellerId;
    }
    // call Push notification
    this.sendPushNotification(this.projectDetails.project_id,
      this.currentUserId, this.projectDetails.buyer_user_id, this.messageToSend, link);

          // call Push notification IOS
    this.sendPushNotification_ios(this.projectDetails.project_id,
      this.currentUserId, this.projectDetails.buyer_user_id, this.messageToSend, link);

    // set UnRead Message Count
    this.removecountFromUnload(this.projectDetails.project_id);

    // clear message typing text box and attachment details
    this.messageToSend = '';
    this.removeAttachedFile();
    this.isScrollToBottom = true;
  }

  // Update Unread Messages
  removecountFromUnload(projectid) {
    this.unReadMessageCount.forEach((item, index) => {
      if (item.projectid === projectid) {
        this.unReadMessageCount[index].count = 0;
        this.globalEventsManager.sendMessageReadArray(this.unReadMessageCount);
      }
    });
  }

  // return thumbnail image to display by attachment url
  public getMessageFileThumbnail(fileType: string, fileUrl: string) {
    return this.sellerService.getThumbnailImages(fileType, fileUrl);
  }


  // convert server timestamp value to date type and return
  public getDate(timestamp: string): Date {
    return new Date(timestamp);
  }

  public messagesContainerOnScroll(event: ScrollEvent) {
    // // if scroll reached top and if window is not scrolled && another message set to display is not generating
    if (!event.isWindowEvent && event.isReachingTop && !this.loadingMoreMessages) {
      this.isScrollToBottom = false;
      this.getMessagesToDisplay();
    }

  }

  // from the initial set of messages, extract set of messages to display on scroll
  getMessagesToDisplay() {
    this.loadingMoreMessages = true;

    if (this.noOfMessagesPerScroll === 0) {
      return;
    }

    // tslint:disable-next-line:max-line-length
    // tslint:disable-next-line:prefer-const
    let startIndex = (this.messagesScrollStartIndex - this.noOfMessagesPerScroll < 0) ? 0 : this.messagesScrollStartIndex - this.noOfMessagesPerScroll;

    // tslint:disable-next-line:prefer-const
    let messagesToAdd = this.initialSetOfMessages.slice(startIndex, this.messagesScrollStartIndex);
    if (messagesToAdd.length > 0) {
      this.messages = messagesToAdd.concat(this.messages);
    }
    this.messagesScrollStartIndex = startIndex;
    this.loadingMoreMessages = false;
  }


  // from the initial set of messages, extract set of messages to display on scroll
  getMessagesCoWorkersToDisplay() {
    this.loadingMoreMessagesCoWorker = true;

    if (this.noOfMessagesPerScrollCoWorker === 0) {
      return;
    }

    // tslint:disable-next-line:max-line-length
    // tslint:disable-next-line:prefer-const
    let startIndex = (this.messagesScrollStartIndexCoWorker - this.noOfMessagesPerScrollCoWorker < 0) ? 0 : this.messagesScrollStartIndexCoWorker - this.noOfMessagesPerScrollCoWorker;

    // tslint:disable-next-line:prefer-const
    let messagesToAdd = this.initialSetOfMessagesCoWorkers.slice(startIndex, this.messagesScrollStartIndexCoWorker);
    if (messagesToAdd.length > 0) {
      this.messagesCoWorkers = messagesToAdd.concat(this.messagesCoWorkers);
    }
    this.messagesScrollStartIndexCoWorker = startIndex;
    this.loadingMoreMessagesCoWorker = false;
  }

  public messagesContainerOnScrollCoWokers(event: ScrollEvent) {
    // // if scroll reached top and if window is not scrolled && another message set to display is not generating
    if (!event.isWindowEvent && event.isReachingTop && !this.loadingMoreMessages) {
      this.isScrollToBottomCoWorker = false;
      this.getMessagesCoWorkersToDisplay();
    }

  }

  // push notification file type
  getpushnotificationfiletype(filetype) {
    if (filetype === 'image') {
      return 'Image file';
    } else if (filetype === 'video') {
      return 'Video file';
    } else if (filetype === 'audio') {
      return 'Audio file';
    } else {
      return 'Document';
    }
  }

  // send push notification
  sendPushNotification(projectid, sendderid, recipient_id, message, link) {
    const body = {
      project_id: projectid,
      sender_id: sendderid,
      recipient_id: recipient_id,
      message: message,
      link: link
    };
    this.sellerService.sendPushNotification(body).subscribe(res => {
      if (res != null) {
      }
    }, err => {
    //  console.log(err);
    });
  }

    // send push notification IOS
    sendPushNotification_ios(projectid, sendderid, recipient_id, message, link) {
      const body = {
        project_id: projectid,
        sender_id: sendderid,
        recipient_id: recipient_id,
        message: message,
        link: link
      };
      this.sellerService.sendPushNotification_ios(body).subscribe(res => {
        if (res != null) {
        }
      }, err => {
        // console.log(err);
      });
    }

  // =================================================== END SECTION MESSAGING ===================================================
  //#endregion

  //#region Files Section Start From Here
  // =================================================== START SECTION FILES ===================================================

  // View Image By Click
  viewImageFile(filepath) {
    this.viewimageFilePath = filepath;
  }

  callFileTabClick(value): void {
    if (this.isEditableOptionEnable) {
      this.globalEventsManager.sendopenConfirmationModal(true);
      return;
    }

    this.righttabIdentify = value;
    // this.totalCount = 0;
    // this.imageCount = 0;
    // this.docCount = 0;
    // this.audioCount = 0;
    // this.videoCount = 0;
    // this.otherCount = 0;
    this.filesStartNo = 0;
    this.selectedFiles = [];
    this.activeformatindex = 0;
    this.activityFiles = [];
    if (this.environmentFilter === 'external_activities') {
      this.getActivityFiles(CommonConstants.ACTIVITY_TYPE_EXTERNAL);
    } else {
      this.getActivityFiles(CommonConstants.ACTIVITY_TYPE_INTERNAL);
    }
  }

  // get activity files
  public getActivityFiles(activity_type: string) {
    if (this.filesStartNo > this.activityFiles.length) {
      return;
    }
    this.loadingMoreFiles = true;
    this.sellerService.getActivityFiles(this.projectDetails.project_id, this.currentUserId, activity_type,
      this.selectedFileType, this.filesStartNo, this.noOfFilesPerLoad).subscribe(res => {
        if (res && res.total_count && res.data) {
          this.noOfAllActivityFiles = res.total_count;

          if (this.activityFiles.length > 0) {
            this.activityFiles = this.activityFiles.concat(res.data);
          } else {
            this.activityFiles = res.data;
          }

          this.filesStartNo = this.filesStartNo + this.noOfFilesPerLoad;

          // bind data to counts display
          if (this.selectedFileType === CommonConstants.FILE_TYPE_ALL) {
            this.totalCount = (res.total_count) ? res.total_count : 0;
            this.imageCount = (res.image_count) ? res.image_count : 0;
            this.docCount = (res.doc_count) ? res.doc_count : 0;
            this.audioCount = (res.audio_count) ? res.audio_count : 0;
            this.videoCount = (res.video_count) ? res.video_count : 0;
            this.otherCount = (res.other_count) ? res.other_count : 0;
          }

        } else {
          if (this.activeformatindex === 0) {
            this.totalCount = (res.total_count) ? res.total_count : 0;
            this.imageCount = (res.image_count) ? res.image_count : 0;
            this.docCount = (res.doc_count) ? res.doc_count : 0;
            this.audioCount = (res.audio_count) ? res.audio_count : 0;
            this.videoCount = (res.video_count) ? res.video_count : 0;
            this.otherCount = (res.other_count) ? res.other_count : 0;
          }

        }
        this.loadingMoreFiles = false;

      }, err => {
        console.log(err);
        this.loadingMoreFiles = false;
      });
  }

  // Update the Count For the Projects
  getActivityFilesCount(activity_type: string) {
    this.sellerService.getActivityFilesCount(this.projectDetails.project_id, this.currentUserId, activity_type).subscribe(res => {
      if (res) {
        this.imageCount = (res.image_count) ? res.image_count : 0;
        this.docCount = (res.doc_count) ? res.doc_count : 0;
        this.audioCount = (res.audio_count) ? res.audio_count : 0;
        this.videoCount = (res.video_count) ? res.video_count : 0;
        this.otherCount = (res.other_count) ? res.other_count : 0;
        this.totalCount = this.docCount + this.audioCount + this.videoCount + this.otherCount + this.imageCount;
      }
    }, err => {
      console.log(err);
    });
  }

  public fileTypeSelected(selectedFileType: string) {
    this.selectedFileType = selectedFileType;
    this.filesStartNo = 0;
    this.activityFiles = [];
    this.selectedFiles = [];
    if (this.selectAllFilesCheckBox) {
      this.selectAllFilesCheckBox.nativeElement.checked = false;
    }

    if (this.environmentFilter === 'external_activities') {
      this.getActivityFiles(CommonConstants.ACTIVITY_TYPE_EXTERNAL);
    } else {
      this.getActivityFiles(CommonConstants.ACTIVITY_TYPE_INTERNAL);
    }
  }
  callFilesFromClient(fileenvirn): void {
    // this.totalCount = 0;
    // this.imageCount = 0;
    // this.docCount = 0;
    // this.audioCount = 0;
    // this.videoCount = 0;
    // this.otherCount = 0;
    this.selectedFiles = [];
    this.environmentFilter = fileenvirn;
    // this.activeformatindex = 0;
    // load Files tab data
    this.fileTypeSelected(this.selectedFileType);
    if (this.selectedFileType !== CommonConstants.FILE_TYPE_ALL) {
      if (this.environmentFilter === 'external_activities') {
        this.getActivityFilesCount(CommonConstants.ACTIVITY_TYPE_EXTERNAL);
      } else {
        this.getActivityFilesCount(CommonConstants.ACTIVITY_TYPE_INTERNAL);
      }
    }
  }



  // select or deselect all files
  public selectAllFilesClicked(isChecked: boolean) {

    // check all check boxes
    this.selectFileCheckBoxs.forEach(element => {
      element.nativeElement.checked = isChecked;
    });

    // remove all selected file
    this.selectedFiles = [];

    // if checked true, re-add all activity files into selected files
    if (isChecked) {
      this.selectedFiles = [];
      this.activityFiles.forEach(element => {
        this.selectedFiles.push(element);
      });
    }

  }

  // remove selected files from files section
  public deleteFiles(modalCloseBtn) {

    // tslint:disable-next-line:prefer-const
    let fileIdsToDelete: number[] = [];
    this.selectedFiles.forEach(element => {
      fileIdsToDelete.push(element.safety_box_file_id);
    });

    this.sellerService.deleteFiles(fileIdsToDelete).subscribe(res => {

      // remove from list
      this.selectedFiles.forEach(element => {
        // tslint:disable-next-line:prefer-const
        let indexOfItemToRemove = this.activityFiles.findIndex(m => m.safety_box_file_id === element.safety_box_file_id);

        if (indexOfItemToRemove > -1) {
          // tslint:disable-next-line:prefer-const
          let removedItem = this.activityFiles.splice(indexOfItemToRemove, 1);

          // reduce counts
          switch (removedItem[0].file_type) {

            case CommonConstants.FILE_TYPE_IMAGE:
              this.imageCount = this.imageCount - 1;
              break;

            case CommonConstants.FILE_TYPE_DOC:
              this.docCount = this.docCount - 1;
              break;

            case CommonConstants.FILE_TYPE_AUDIO:
              this.audioCount = this.audioCount - 1;
              break;

            case CommonConstants.FILE_TYPE_VIDEO:
              this.videoCount = this.videoCount - 1;
              break;

            case CommonConstants.FILE_TYPE_OTHER:
              this.otherCount = this.otherCount - 1;
              break;

          }
          this.totalCount = this.totalCount - 1;
        }
      });

      //   close modal by triggering close modal btn click
      $(this.deleteFilesConfirmationModal.nativeElement).modal('hide');
      this.selectedFiles = [];

    }, err => {
      $(this.deleteFilesConfirmationModal.nativeElement).modal('hide');
      console.log(err);
    });
  }

  // Close the Delete Modal
  declineDeleteFilesModal(): void {
    $(this.deleteFilesConfirmationModal.nativeElement).modal('hide');
  }

  // return thumbnail image to display - depends on attached file type
  public getFileThumbnail(fileUrl: string, fileType: string) {
    return this.sellerService.getThumbnailImages(fileType, fileUrl);
  }

  // update select file list
  public selectFileCheckBoxChanged(isChecked: boolean, file: any) {

    // if check add to selected file
    if (isChecked) {
      this.selectedFiles.push(file);
    } else {
      // tslint:disable-next-line:prefer-const
      let indexOfItemToRemove = this.selectedFiles.indexOf(file);
      if (indexOfItemToRemove > -1) {
        this.selectedFiles.splice(indexOfItemToRemove, 1);
      }
    }
  }

  // download selected files
  public downloadSelectedFiles() {

    // if no files selected
    if (!this.selectedFiles || this.selectedFiles.length === 0) {
     //  alert('Please select files to download');
      return;
    }

    // tslint:disable-next-line:prefer-const
    let zip = new JSZip();

    this.selectedFiles.forEach((element, index) => {

      // for each selected file generate blog from file url
      this.sellerService.getFileAsBlob(element.activity_file_path).subscribe(res => {

        // add blobed file into zipe
        zip.file(element.activity_file_path.split('/').slice(-1), res);

        // if all selected files are added into zip, download zip
        if (index === this.selectedFiles.length - 1) {

          zip.generateAsync({ type: 'blob' }, (metadata) => {

            // display while zip file generating
            this.loaderActivate = true;

          }).then((blob) => {

            // download zip
            // tslint:disable-next-line:prefer-const
            let downloadUrl = window.URL.createObjectURL(blob);
            window.open(downloadUrl);
            this.loaderActivate = false;

          }, function (err) {

          });
        }
      }, err => {

      });
    });

  }

  public filesContainerOnScroll(event: ScrollEvent) {
    // if scroll reached bottom and if window is not scrolled && another file set is not loading
    if (event.isReachingBottom && !this.loadingMoreFiles) {
      if (this.environmentFilter === 'external_activities') {
        this.getActivityFiles(CommonConstants.ACTIVITY_TYPE_EXTERNAL);
      } else {
        this.getActivityFiles(CommonConstants.ACTIVITY_TYPE_INTERNAL);
      }
    }

  }


  // upload attached file into s3 bucket
  public uploadFileUsingFilesection() {
    if (!this.fileData || this.fileData.length <= 0) {
      return;
    }
    let namedirect = '';
    if (this.environmentFilter === 'external_activities') {
      namedirect = CommonConstants.ACTIVITY_TYPE_EXTERNAL;
    } else {
      namedirect = CommonConstants.ACTIVITY_TYPE_INTERNAL;
    }

    this.fileData.forEach((element, index) => {
      this.uploadingAttachment = true;
      // call file upload
      this.sellerService.uploadAttachedFile(element.file, this.projectDetails.project_id, this.currentUserId,
        this.attachedFileType, namedirect, false).subscribe(res => {
          if (res !== 'No file part') {
            this.attachmentUrl = res.activity_url;
            this.uploadingAttachment = false;
          }

        }, err => {
          console.log(err);
          this.uploadingAttachment = false;
        });
      if (this.fileData.length - 1 === index) {
        this.removeAttachedFile();
        this.isScrollToBottom = true;
        this.activityFiles = [];
        this.filesStartNo = 0;
        setTimeout(() => {
          if (this.environmentFilter === 'external_activities') {
            this.getActivityFiles(CommonConstants.ACTIVITY_TYPE_EXTERNAL);
          } else {
            this.getActivityFiles(CommonConstants.ACTIVITY_TYPE_INTERNAL);
          }
        }, 1500);
      }
    });

  }


  // =================================================== END SECTION FILES ===================================================
  //#endregion

  //#region  Agreement Section Start
  // =================================================== START AGREEMENT CREATE OFFER ===================================================


  // To Open the Draft Modal
  closeAgreementDraft() {
    $(this.closeAgreementModalWarning.nativeElement).modal('show');
  }

  // Save Agreement Draft
  callAgreementDraftSave() {
    $(this.closeAgreementModalWarning.nativeElement).modal('hide');
    this.agreementCreateWithDraft(1);
  }

  // No need to save Agreement Draft
  callNoNeedAgreementDraftSave() {
    $(this.closeAgreementModalWarning.nativeElement).modal('hide');
    this.closeMainAgreementModalByHidden.nativeElement.click();
  }



  agreementCreateStep1NextLevel(model: any, isValid: boolean, step: string): void {
    if (!isValid) {
      return;
    }
    if (step === 'firststep') {
      this.activeStep = 2;
    } else if (step === 'secondstep') {
      this.activeStep = 3;
    } else if (step === 'thirdstep') {
      this.activeStep = 4;
    } else if (step === 'fourthstep') {
      this.activeStep = 5;
    } else if (step === 'fifthstep') {
      this.activeStep = 6;
    } else if (step === 'sixthstep') {
      this.activeStep = 7;
    } else if (step === 'seventhstep') {
      this.activeStep = 8;
    } else if (step === 'eightthstep') {
      this.activeStep = 9;
    } else if (step === 'ninethstep') {
      this.activeStep = 10;
    }
    // console.log(this.agreementCreate);
  }


  // check validation
  firstItemCheckValidation(valid) {
   this.activateFistStepValidation = valid;
    return this.activateFistStepValidation;
  }
  // Second Item
  secondItemTabCheckValidation(valid) {
    this.activateSecondStepValidation = valid;
    return this.activateSecondStepValidation;
  }

  // Last Tab Validation
  lastItemTabCheckValidation(valid) {
    this.activateLastStepValidation = valid;
     return this.activateLastStepValidation;
   }


  priceOptionChange(optionValueData: string): void {
    if (optionValueData === 'Fast pris') {
      this.agreementCreate.priceOption1 = 'Fast pris';
      this.agreementCreate.priceOption2 = '';
      this.agreementCreate.priceOption3 = '';
      if (this.agreementCreate.isTotalFastPrice) {
        this.agreementCreate.total_price = this.agreementCreate.fastpriceTotal;
      } else {
        this.agreementCreate.total_price = this.agreementCreate.fastpriceArbete +
          this.agreementCreate.fastpriceMaterial + this.agreementCreate.fastpriceResor;
      }

      // check the price
      (this.agreementCreate.total_price) ?
      this.activateLastStepValidation = true : this.activateLastStepValidation = false;

    } else if (optionValueData === 'Ungefärlig prisuppgift') {
      this.agreementCreate.priceOption1 = '';
      this.agreementCreate.priceOption2 = 'Ungefärlig prisuppgift';
      this.agreementCreate.priceOption3 = '';
      this.agreementCreate.total_price = this.agreementCreate.ungefarligprisuppgift;
      // check the price
      (this.agreementCreate.total_price) ?
      this.activateLastStepValidation = true : this.activateLastStepValidation = false;
    } else if (optionValueData === 'Löpande räkning​') {
      this.agreementCreate.priceOption1 = '';
      this.agreementCreate.priceOption2 = '';
      this.agreementCreate.priceOption3 = 'Löpande räkning​';
      this.activateLastStepValidation = true;
    }

  }

  // on change the Fast Price Issue
  onChangeFastPrice(): void {
    if (this.agreementCreate.isTotalFastPrice) {
      this.agreementCreate.total_price = this.agreementCreate.fastpriceTotal;
    } else {
      this.agreementCreate.total_price = this.formatPriceValues(this.agreementCreate.fastpriceArbete) +
        this.formatPriceValues(this.agreementCreate.fastpriceMaterial) + this.formatPriceValues(this.agreementCreate.fastpriceResor);
    }

    // check the price
    (this.agreementCreate.total_price === 0) ? this.activateLastStepValidation = false : this.activateLastStepValidation = true;
  }

  // Price Option 2
  onChangePriceOption2() {
    this.agreementCreate.total_price = this.agreementCreate.ungefarligprisuppgift;
    // check the price
    (this.agreementCreate.total_price === 0 || this.agreementCreate.total_price === null) ?
      this.activateLastStepValidation = false : this.activateLastStepValidation = true;
  }

  formatPriceValues(data: any) {
    if (data == null || data === undefined) {
      return 0;
    }
    return data;
  }

  formatPriceValuesPDF(data: any) {
    if (data == null || data === undefined) {
      return '-';
    }
    return this.format1(Number(data), null);
  }

  formatPriceValuesPDFPercentage(data: any) {
    if (data == null || data === undefined) {
      return '-';
    }
    return data;
  }

  format1(n, currency) {
    return n.toFixed(2).replace(/./g, function (c, i, a) {
      return i > 0 && c !== '.' && (a.length - i) % 3 === 0 ? ',' + c : c;
    });
  }

  removeundefinevalue(data) {
    if (data === null || typeof data === 'undefined') {
      return '-';
    }
    return data;
  }

  // agreement create Fully
  agreementCreateOffer(model: any, isValid: boolean, draft: number): void {
    if (this.agreementCreate.priceOption3 !== 'Löpande räkning​') {
      if (this.agreementCreate.total_price === null || typeof this.agreementCreate.total_price === 'undefined') {
        return;
      }
    }

    if (this.agreementCreate.total_price === 0) {
      this.agreementCreate.total_price = null;
      return;
    }
    if (!isValid) {
      return;
    }
    this.agreementCreateWithDraft(draft);

  }

  // agreement create with Draft || main Agreement
  agreementCreateWithDraft(draft: number) {
    // tslint:disable-next-line:prefer-const
    let pricestringhtml = '';
    // tslint:disable-next-line:prefer-const
    let billablehourshtml = '';
    // tslint:disable-next-line:prefer-const
    let lopanderakning = '';
    // tslint:disable-next-line:prefer-const
    let resoroptionfinal = '';
    // tslint:disable-next-line:prefer-const
    let optionalNumber = '';

    // identitynumberperson1
    if (typeof this.agreementCreate.identitynumberperson1 === 'undefined') {
      this.agreementCreate.identitynumberperson1 = '';
    }
    // identitynumberperson 2
    if (typeof this.agreementCreate.identitynumberperson2 === 'undefined') {
      this.agreementCreate.identitynumberperson2 = '';
    }

    // tslint:disable-next-line:typeof-compare
    if (typeof this.agreementCreate.firstStepPhonenumber1 === 'undefined') {
      optionalNumber = '';
    } else {
      optionalNumber = this.agreementCreate.firstStepPhonenumber1.toString();
    }

    if (typeof this.agreementCreate.nameperson2 === 'undefined') {
      this.agreementCreate.nameperson2 = '';
    }

    if (typeof this.agreementCreate.sellercompanyinsurance === 'undefined') {
      this.agreementCreate.sellercompanyinsurance = '';
    }

    if (typeof this.agreementCreate.buyeraddressservicetakeplace === 'undefined') {
      this.agreementCreate.buyeraddressservicetakeplace = '';
    }

    if (typeof this.agreementCreate.buyerworkdescription === 'undefined') {
      this.agreementCreate.buyerworkdescription = '';
    }

    if (typeof this.agreementCreate.buyerworkspecification === 'undefined') {
      this.agreementCreate.buyerworkspecification = '';
    }

    if (typeof this.agreementCreate.buyerworkExecuted === 'undefined') {
      this.agreementCreate.buyerworkExecuted = '';
    }

    if (typeof this.agreementCreate.buyerworknotrecommended === 'undefined') {
      this.agreementCreate.buyerworknotrecommended = '';
    }

    if (typeof this.agreementCreate.additionalagreement === 'undefined') {
      this.agreementCreate.additionalagreement = '';
    }

    // tslint:disable-next-line:prefer-const this.formatDate(this.attachmentcreatedDate)  +
    // let uploadlinks = '<tr>' +
    //   '                            <td height="20" colspan="1">Arbetet ska också utföras enligt' +
    //   '                                <span class="pl-2 text-secondary"></span>' +
    //   '                            </td>' +
    //   '                        </tr>';
    let uploadlinks = '';
    let attachmentDescription = '';
    if (this.attachmentBottom) {
      attachmentDescription = '<tr>' +
        '                           <td colspan="2">' + 'Arbete ska utföras enligt arbetsbeskrivning som ses i avtalets Appendix' +
        '                              <span class="pl-2 text-secondary">  </span>' +
        '                           </td>' +
        '                        </tr>';
      uploadlinks = attachmentDescription + uploadlinks;

    } else {
      attachmentDescription = '';

      uploadlinks = attachmentDescription + uploadlinks;
    }



    // tslint:disable-next-line:prefer-const
    let pagebreakfirsttwo = '';
    // tslint:disable-next-line:prefer-const
    let pagebreaklastprice = '';
    // tslint:disable-next-line:prefer-const
    let pageHbreaklastprice = '';
    // tslint:disable-next-line:prefer-const
    let pageFbreaklastprice = '';
    // tslint:disable-next-line:prefer-const
    let pageGbreaklastprice = '';
    // tslint:disable-next-line:prefer-const
    let pageJbreaklastprice = '';
    // tslint:disable-next-line:prefer-const
    let totalPriceDefine = '';
    if (this.agreementCreate.priceOption1 === 'Fast pris') {

      if (this.agreementCreate.isTotalFastPrice) {
        pricestringhtml = '<!-- billable hours -->' +
          '          <div class="col-12 border-secondary">' +
          '            <div id="billableHours">' +
          '              <div class="row mt-4">' +
          '                <h5>Fast pris</h5>' +
          '              </div>' +
          '              <div class="row mt-2">' +
          '<div class="table-responsive">' +
          '<table class="table table-bordered">' +
          '                     <tbody>' +
          '<tr>' +
          '                           <td colspan="1">Totalpris projekt (inkl. moms)' +
          '                              <span class="text-secondary">' +
          this.formatPriceValuesPDF(this.agreementCreate.fastpriceTotal) + '</span>' +
          '                           </td>' +
          '                        </tr>' +
          '</tbody>' +
          '                  </table>' +
          '</div>' +
          '              </div>' +
          '            </div>' +
          '          </div>';

      } else {
        // tslint:disable-next-line:prefer-const
        let fastprice = this.agreementCreate.fastpriceArbete + this.agreementCreate.fastpriceMaterial + this.agreementCreate.fastpriceResor;
        pricestringhtml =
          '          <div class="col-12 border-secondary">' +
          '<div id="fixedPrice">' +
          '              <div class="row mt-4">' +
          '                <h5>Fast pris</h5>' +
          '              </div>' +
          '              <div class="row mt-4">' +
          '<div class="table-responsive">' +
          '<table class="table table-bordered">' +
          '                     <tbody>' +
          '<tr>' +
          '                           <td colspan="1">Totalpris för arbete, material och resor ' +
          '                              <span class="text-secondary">' +
          this.formatPriceValuesPDF(this.formatPriceValues(this.agreementCreate.fastpriceArbete) +
            this.formatPriceValues(this.agreementCreate.fastpriceMaterial)
            + this.formatPriceValues(this.agreementCreate.fastpriceResor)) + '</span> kr inklusive moms' +
          '                           </td>' +
          '                        </tr>' +
          '<tr>' +
          '                           <td colspan="1">Arbete ' +
          '                              <span class="text-secondary">' +
          this.formatPriceValuesPDF(this.formatPriceValues(this.agreementCreate.fastpriceArbete)) + '</span> kr inklusive moms' +
          '                           </td>' +
          '                        </tr>' +
          '<tr>' +
          '                           <td colspan="1">Material ' +
          '                              <span class="text-secondary">' +
          this.formatPriceValuesPDF(this.formatPriceValues(this.agreementCreate.fastpriceMaterial)) +
          '</span> kr inklusive moms' +
          '                           </td>' +
          '                        </tr>' +
          '<tr>' +
          '                           <td colspan="1">Resor ' +
          '                              <span class="text-secondary">' +
          this.formatPriceValuesPDF(this.formatPriceValues(this.agreementCreate.fastpriceResor)) +
          '</span> kr inklusive moms' +
          '                           </td>' +
          '                        </tr>' +

          '</tbody>' +
          '                  </table>' +
          '</div>' +
          '              </div>' +
          '            </div>' +
          '            </div>';
      }

      totalPriceDefine = '<tr><td colspan="2">Project cost' +
        '                              <span class="pl-2 text-secondary">'
        + this.formatPriceValuesPDF(this.agreementCreate.total_price) + ' kr</span>' +
        '                           </td> </tr>';


      if (this.agreementCreate.taxdeduction === 'Yes') {
        if (this.agreementCreate.isTotalFastPrice) {
          pagebreakfirsttwo = '<div style="page-break-before:always"> </div>';
          pagebreaklastprice = '';
          pageFbreaklastprice = '';
          pageJbreaklastprice = '';
          pageGbreaklastprice = '';
          pageHbreaklastprice = '<div style="page-break-before:always"> </div>';

        } else {
          pagebreakfirsttwo = '<div style="page-break-before:always"> </div>';
          pagebreaklastprice = '';
          pageFbreaklastprice = '';
          pageJbreaklastprice = '';
          pageGbreaklastprice = '<div style="page-break-before:always"> </div>';
          pageHbreaklastprice = '';
        }
      } else {
        pagebreakfirsttwo = '<div style="page-break-before:always"> </div>';
        pagebreaklastprice = '';
        pageFbreaklastprice = '';
        pageJbreaklastprice = '';
        pageHbreaklastprice = '<div style="page-break-before:always"> </div>';
        pageGbreaklastprice = '';
      }

    }

    if (this.agreementCreate.priceOption2 === 'Ungefärlig prisuppgift') {
      billablehourshtml =
        '<!-- billable hours -->' +
        '          <div class="col-12 border-secondary">' +
        '            <div id="billableHours">' +
        '              <div class="row mt-4">' +
        '                <h5>Ungefärlig prisuppgift</h5>' +
        '              </div>' +
        '              <div class="row mt-4">' +
        '<div class="table-responsive">' +
        '<table class="table table-bordered">' +
        '                     <tbody>' +
        '<tr>' +
        '                           <td colspan="1">Ungefärlig prisuppgift' +
        '                              <span class="text-secondary">' +
        this.formatPriceValuesPDF(this.agreementCreate.ungefarligprisuppgift) +
        '</span> kr (avser arbete och material om inget annat anges) inklusive moms.' +
        '                           </td>' +
        '                        </tr>' +
        '</tbody>' +
        '                  </table>' +
        '</div>' +
        '              </div>' +
        '            </div>' +
        '            </div>';

      totalPriceDefine = '<tr><td colspan="2">Project cost' +
        '                              <span class="pl-2 text-secondary">' +
        this.formatPriceValuesPDF(this.agreementCreate.total_price) + ' kr</span>' +
        '                           </td> </tr>';
      pagebreakfirsttwo = '<div style="page-break-before:always"> </div>';
      pagebreaklastprice = '';
      pageFbreaklastprice = '';
      pageJbreaklastprice = '';
      pageHbreaklastprice = '<div style="page-break-before:always"> </div>';
      pageGbreaklastprice = '';
    }


    if (this.agreementCreate.priceOption3 === 'Löpande räkning​') {
      lopanderakning = '<!-- billable hours -->' +
        '          <div class="col-12 border-secondary">' +
        '            <div id="billableHours">' +
        '              <div class="row mt-4">' +
        '                <h5>Löpande räkning</h5>' +
        '              </div>' +
        '              <div class="row mt-2">' +
        '<div class="table-responsive">' +
        '<table class="table table-bordered">' +
        '                     <tbody>' +
        '<tr>' +
        '                           <td>Arbete' +
        '                              <span class="text-secondary">' +
        this.formatPriceValuesPDF(this.agreementCreate.lopandeArbete) + '</span> kr/tim inklusive entreprenörarvode och moms.' +
        '                           </td>' +
        '                        </tr>' +
        '<tr>' +
        '                           <td>Arbetsledning' +
        '                              <span class="text-secondary">' +
        this.formatPriceValuesPDF(this.agreementCreate.lopandeArbetsledning) + '</span> kr/tim inklusive entreprenörarvode och moms.' +
        '                           </td>' +
        '                        </tr>' +
        '<tr>' +
        '                           <td>Överenskomna underentreprenader debiteras med redovisad' +
        ' självkostnad med tillägg för entreprenörarvode om' +
        '                              <span class="text-secondary">' +
        this.formatPriceValuesPDFPercentage(this.agreementCreate.lopandeOverenskomna) + '</span>%. Moms tillkommer.' +
        '                           </td>' +
        '                        </tr>' +
        '<tr>' +
        '                           <td>Material, varor, hjälpmedel och övriga' +
        ' kostnader debiteras med redovisad själv kostnad med tillägg för entreprenörarvode om ' +
        '                              <span class="text-secondary">' +
        this.formatPriceValuesPDFPercentage(this.agreementCreate.lopandeMaterial) + '</span> %. Moms tillkommer.' +
        '                           </td>' +
        '                        </tr>' +
        '<tr>' +
        '                           <td>Resor' +
        '                              <span class="text-secondary">' +
        this.removeundefinevalue(this.agreementCreate.lopandeResorDetails) + '</span>' +
        '                           </td>' +
        '                        </tr>' +
        '</tbody>' +
        '                  </table>' +
        '</div>' +
        '              </div>' +
        '            </div>' +
        '          </div>';


      resoroptionfinal = '<div class="col-12 pl-5">' +

        '          </div>';


      totalPriceDefine = '<tr><td style="width: 20%">Project cost' +
        '</td> <td width: 80%;">' +
        '<div class="table-responsive" style="overflow-x: hidden;overflow-y: hidden">' +
        '<table class="table">' +
        '                     <tbody>' +
        '<tr><td colspan="1" style="border:0 !important;"><h5>Löpande räkning</h5>' +
        '</td> </tr>' +
        '<tr>' +
        '<td colspan="2">Arbete timkostnad (inkl. moms och entreprenörarvode)' +
        '    <span class="pl-2 text-secondary">' + this.formatPriceValuesPDF(this.agreementCreate.lopandeArbete) + '</span> kr/timme' +
        '                           </td>' +
        '</tr>' +
        '<tr>' +
        '<td colspan="2">Arbetsledning timkostnad (inkl. moms och entreprenörarvode)' +
        '    <span class="pl-2 text-secondary">' + this.formatPriceValuesPDF(this.agreementCreate.lopandeArbetsledning) +
        '</span> kr/timme' +
        '                           </td>' +
        '</tr>' +
        '<tr>' +
        '<td colspan="2">Överenskomna underentreprenader debiteras med redovisad självkostnad med tillägg för entreprenörarvode om' +
        '    <span class="pl-2 text-secondary">' +
        this.formatPriceValuesPDFPercentage(this.agreementCreate.lopandeOverenskomna) + '</span> % (moms tillkommer)' +
        '                           </td>' +
        '</tr>' +
        '<tr>' +
        '<td colspan="2">Material, varor, hjälpmedel och övriga kostnader debiteras med redovisad' +
        ' självkostnad med tillä̈gg för entreprenörarvode om' +
        '    <span class="pl-2 text-secondary">' +
        this.formatPriceValuesPDFPercentage(this.agreementCreate.lopandeMaterial) + '</span> % (moms tillkommer)' +
        '                           </td>' +
        '</tr>' +
        '<tr>' +
        '<td colspan="2">Resor debiteras enligt' +
        '    <span class="pl-2 text-secondary">'
        + this.removeundefinevalue(this.agreementCreate.lopandeResorDetails) + '</span>' +
        '                           </td>' +
        '</tr>'
        +
        '</tbody>' +
        '                  </table>' +
        '</div>' +
        '</td></tr>';

      if (this.agreementCreate.taxdeduction === 'Yes') {
        pagebreakfirsttwo = '';
        pagebreaklastprice = '';
        pageFbreaklastprice = '<div style="page-break-before:always"> </div>';
        pageJbreaklastprice = '<div style="page-break-before:always"> </div>';
        pageHbreaklastprice = '';
        pageGbreaklastprice = '';
      } else {
        pagebreakfirsttwo = '';
        pagebreaklastprice = '<div style="page-break-before:always"> </div>';
        pageFbreaklastprice = '';
        pageJbreaklastprice = '';
        pageHbreaklastprice = '<div style="page-break-before:always"> </div>';
        pageGbreaklastprice = '';
      }

    }



    // tslint:disable-next-line:prefer-const
    let inlineCheckbox6 = '';
    // tslint:disable-next-line:prefer-const
    let inlineCheckbox7 = '';
    // tslint:disable-next-line:prefer-const
    let taxdeductionhtml = '';
    if (this.agreementCreate.taxdeduction === 'Yes') {
      inlineCheckbox6 = '<input class="form-check-input" type="checkbox" id="inlineCheckbox6" value="option1" checked>';
      inlineCheckbox7 = '<input class="form-check-input" type="checkbox" id="inlineCheckbox7" value="option2">';
      taxdeductionhtml = '<tr>' +
        '                           <td colspan="2">Fastighets-/bostadsrätts-/ägarlägenhetsbeteckning  ' +
        '                            <span class="text-secondary">' + this.agreementCreate.propertyId + ' </span></td>' +
        '                        </tr>' +
        '                        <tr>' +
        '                           <td colspan="2">Bostadsrättsföreningens organisationsnummer  ' +
        '<span class="text-secondary">' + this.agreementCreate.propertyorgno + '</span></td>' +
        '                        </tr>' +
        '                        <tr>' +
        '                           <td colspan="2">Vilken/vilka beställare ska ROT-avdrag sökas för  ' +
        '<span class="text-secondary">' + this.agreementCreate.individualtaxdeduction + '</span></td>' +
        '                        </tr>';
    } else {
      inlineCheckbox6 = '<input class="form-check-input" type="checkbox" id="inlineCheckbox6" value="option1">';
      inlineCheckbox7 = '<input class="form-check-input" type="checkbox" id="inlineCheckbox7" value="option2" checked>';
      taxdeductionhtml = '';
    }

    // tslint:disable-next-line:prefer-const
    let inlineCheckbox14 = '';
    // tslint:disable-next-line:prefer-const
    let inlineCheckbox15 = '';
    // tslint:disable-next-line:prefer-const
    let inlineCheckbox16 = '';
    // tslint:disable-next-line:prefer-const
    let inlineCheckbox17 = '';

    if (this.agreementCreate.paymentOption1) {
      inlineCheckbox14 = '<input class="form-check-input" type="checkbox" id="inlineCheckbox14" value="option2" checked>';
    } else {
      inlineCheckbox14 = '<input class="form-check-input" type="checkbox" id="inlineCheckbox14" value="option2">';
    }

    if (this.agreementCreate.paymentOption2) {
      inlineCheckbox15 = '<input class="form-check-input" type="checkbox" id="inlineCheckbox15" value="option2" checked>';
    } else {
      inlineCheckbox15 = '<input class="form-check-input" type="checkbox" id="inlineCheckbox15" value="option2">';
    }

    if (this.agreementCreate.paymentOption3) {
      inlineCheckbox16 = '<input class="form-check-input" type="checkbox" id="inlineCheckbox16" value="option2" checked>';
    } else {
      inlineCheckbox16 = '<input class="form-check-input" type="checkbox" id="inlineCheckbox16" value="option2">';
    }


    if (this.agreementCreate.paymentOption4) {
      inlineCheckbox17 = '<input class="form-check-input" type="checkbox" id="inlineCheckbox17" value="option2" checked>';
    } else {
      inlineCheckbox17 = '<input class="form-check-input" type="checkbox" id="inlineCheckbox17" value="option2">';
    }

    this.agreementhtmlstring = '<!doctype html>' +
      '<html lang="en">' +
      '  <head>' +
      '    <!-- Required meta tags -->' +
      '    <meta charset="utf-8">' +
      '    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">' +
      '' +
      '    <!-- Bootstrap CSS -->' +
      // tslint:disable-next-line:max-line-length
      '    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css" integrity="sha384-Gn5384xqQ1aoWXA+058RXPxPg6fy4IWvTNh0E263XmFcJlSAwiGgFAW/dAiS6JXm" crossorigin="anonymous">' +
      '<style>  .ml {' +
      '    margin-left: 20px;' +
      '  }' +
      ' .ml-10 {' +
      '    margin-left: 30px;' +
      '  }' +
      ' .ml30 {' +
      '    margin-left: 30px;' +
      '  }' +
      ' .ml40 {' +
      '    margin-left: 40px;' +
      '  }' +
      ' label {' +
      '    width: 100% !important;' +
      '  }' +
      '</style>' +
      '    <title>Hantverkarformuläret - 17</title>' +
      '  </head>' +
      '  <body>' +
      '    <div class="container-fluid">' +
      '      <!-- section A -->' +
      '      <div class="container">' +
      '        <div class="row mt-5">' +
      '          <h3>Hantverkarformuläret -17</h3> </div>' +
      // tslint:disable-next-line:max-line-length
      '  <div class="row">  <p>Den här avtalsmallen kan ni använda vid reparations- och ombyggnadsarbeten där beställaren är konsument och hantverkaren är näringsidkare. Vid ny- och tillbyggnadsarbeten av småhus rekommenderar vi att ni istället använder entreprenadkontrakt ABS. För reparations- och ombyggnadsarbeten gäller konsumenttjänstlagen. Använder ni den här avtalsmallen gäller också de tillhörande allmänna bestämmelserna</p> ' +
      '        </div>' +
      '        <div class="row border-secondary border-bottom mt-3">' +
      '          <h5>A. Parter</h5>' +
      '        </div>' +
      '        <div class="row mt-3">' +
      '          <h5 style="width:100%;">Beställare (konsument)</h5> </div>' +
      '     <div class="row"><div class="table-responsive">' +
      '            <table class="table table-bordered">' +
      '              <tbody>' +
      '                <tr>' +
      '                  <td>Namn <span class="pl-2 text-secondary">' + this.agreementCreate.nameperson1 + '</span></td>' +
      // tslint:disable-next-line:max-line-length
      '                  <td>Personnummer <span class="pl-2 text-secondary">' + this.agreementCreate.identitynumberperson1 + '</span></td>' +
      '                </tr>' +
      '                <tr>' +
      '                  <td>Namn<span class="pl-2 text-secondary">' + this.agreementCreate.nameperson2 + '</span></td>' +
      '                  <td>Personnummer<span class="pl-2 text-secondary">' + this.agreementCreate.identitynumberperson2 + '</span></td>' +
      '                </tr>' +
      '                <tr>' +
      // tslint:disable-next-line:max-line-length
      '                  <td colspan="2">Adress<span class="pl-2 text-secondary">' + this.agreementCreate.firstStepAddress + '</span></td>' +
      '                </tr>' +
      '                <tr>' +
      // tslint:disable-next-line:max-line-length
      '                  <td>Telefonnummer<span class="pl-2 text-secondary">' + optionalNumber + '</span></td>' +
      '                  <td>E-post<span class="pl-2 text-secondary">' + this.agreementCreate.firstStepemail + '</span></td>' +
      '                </tr>' +
      '              </tbody>' +
      '            </table>' +
      '          </div>' +
      '        </div>' +
      '        <div class="row mt-3">' +
      '          <h5>Hantverkare (näringsidkare)</h5> </div>' +
      '      <div class="row">    <div class="table-responsive">' +
      '            <table class="table table-bordered">' +
      '              <tbody>' +
      '                <tr>' +
      '                  <td>Namn/firma<span class="pl-2 text-secondary">' + this.agreementCreate.sellerorganization + '</span></td>' +
      // tslint:disable-next-line:max-line-length
      '                  <td>Organisations-/personnummer<span class="pl-2 text-secondary">' + this.agreementCreate.sellerregistredNumber + '</span></td>' +
      '                </tr>' +
      '                <tr>' +
      '                  <td colspan="2">Adress<span class="pl-2 text-secondary">' + this.agreementCreate.sellerAddress + '</span></td>' +
      '                </tr>' +
      '                <tr>' +
      '                  <td>Telefonnummer<span class="pl-2 text-secondary">'
      + this.removeundefinevalue(this.agreementCreate.sellerphonenumber) + '</span></td>' +
      '                  <td>E-post<span class="pl-2 text-secondary">' + this.agreementCreate.selleremail + '</span></td>' +
      '                </tr>' +
      '                <tr>' +
      '                  <td colspan="2">' +
      '                    <div class="form-check float-left mr-5">' +
      '                      <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" checked>' +
      '                      <label class="form-check-label" for="defaultCheck1">' +
      '                        Godkänd för F-skatt' +
      '                      </label>' +
      '                    </div>' +
      '                    <span>Har allrisk- och ansvarsförsäkring hos - </span> ' + this.agreementCreate.sellercompanyinsurance +
      '                  </td>' +
      '                </tr>' +
      '              </tbody>' +
      '            </table>' +
      '          </div>' +
      '        </div>' +
      '      </div>' +
      // '<div style="page-break-before:always"> </div>' +
      '      <!-- section B -->'
      +
      '      <div class="container">' +
      '        <div class="row border-secondary border-bottom mt-5">' +
      '          <h5>B. Omfattning</h5>' +
      '        </div>' +
      '        <div class="row mt-3">' +
      '<div class="table-responsive">' +
      '                  <table class="table table-bordered">' +
      '                     <tbody>' +
      '                        <tr>' +
      '                           <td colspan="2">Adress där arbete ska utföras' +
      '                              <span class="pl-2 text-secondary">'
      + this.agreementCreate.buyeraddressservicetakeplace + '</span>' +
      '                           </td>' +
      '                        </tr>' +
      '<tr>' +
      '                           <td colspan="2" height="100">Beskriv tydligt det arbete hantverkaren ska utföra' +
      '                              <span class="pl-2 text-secondary">' + this.agreementCreate.buyerworkdescription + '</span>' +
      '                           </td>' +
      '                        </tr>' +
      uploadlinks
      +
      '                        <tr>' +
      '                            <td height="100" colspan="2">Arbete, material och övrigt som inte ingår' +
      '                                <span class="pl-2 text-secondary"> ' + this.agreementCreate.buyerworkspecification + ' </span>' +
      '                            </td>' +
      '                        </tr>' +
      '' +
      '                        <tr>' +
      '                           <td colspan="2">Om ni inte har avtalat om något annat ska beställaren,' +
      'utan ersättning, se till att hantverkaren har tillgång till elström, vatten, toalett och utrymme för omklädning och matlagning.' +
      '                              <span class="pl-2 text-secondary"></span>' +
      '                           </td>' +
      '                        </tr>' +
      '' +
      '                     </tbody>' +
      '                  </table>' +
      '               </div>'
      +
      '        </div>'
      +
      '      </div>'
      +
      '<div style="page-break-before:always"> </div>' +
      '      <!-- section C -->' +
      '      <div class="container">' +
      '        <div class="row border-secondary border-bottom mt-5">' +
      '          <h5  style="width:100%;">C. Hantverkarens avrådande</h5>' +
      '        </div>' +
      '       <div class="row mt-4">' +
      '               <div class="table-responsive">' +
      '                  <table class="table table-bordered">' +
      '                     <tbody>' +
      '                        <tr>' +
      '                           <td height="100" colspan="2">Arbete som beställaren vill ha utfört trots att hantverkaren har avrått' +
      '                                <span class="pl-2 text-secondary">' + this.agreementCreate.buyerworkExecuted + '</span>' +
      '                           </td>' +
      '                        </tr>' +
      '                        <tr>' +
      '                           <td height="100" colspan="2">Orsak till avrådande' +
      '                                <span class="pl-2 text-secondary">' + this.agreementCreate.buyerworknotrecommended + '</span>' +
      '                           </td>' +
      '                        </tr>' +
      '                     </tbody>' +
      '                  </table>' +
      '               </div>' +
      '            </div>' +
      '      </div>' +

      '      <!-- section D -->' +
      '      <div class="container">' +
      '        <div class="row border-secondary border-bottom mt-5" style="width:100%;">' +
      '          <h5  style="width:100%;">D. Pris</h5>' +
      '        </div>' +
      '        <div class="row mt-3">' +
      // tslint:disable-next-line:max-line-length
      '          <p>Priserna för arbete ska anges nedan utan eventuellt ROT-avdrag. Priserna kan anges antingen som fast pris och/eller löpande räkning.</p>' +
      '        </div>' +
      '        <div class="row mt-4">'
      +
      pricestringhtml
      +
      billablehourshtml
      +
      lopanderakning
      +
      resoroptionfinal
      +
      '        </div>' +
      '      </div>' +
      '      <!-- section E -->' +
      '      <div class="container">' +
      '        <div class="row border-secondary border-bottom mt-5">' +
      '          <h5>E. ROT-avdrag</h5><p class="ml-3" style="width:100%;">Läs punkt 11 i de allmänna bestämmelserna.</p>' +
      '        </div>' +
      '<div class="row mt-4">' +
      '               <div class="table-responsive">' +
      '                  <table class="table table-bordered">' +
      '                     <tbody>' +
      '                        <tr>' +
      '                           <td style="width: 50%;">' +
      '                              <div class="form-check form-check-inline" ' +
      ' style="display: -webkit-inline-box;-webkit-box-align: center;">' +
      inlineCheckbox6 +
      '  <label class="form-check-label" for="inlineCheckbox6" ' +
      ' style="width:100%;display: block;margin-left: 10px;">Ja, arbete ska utföras med ROT-avdrag.' +
      ' Hantverkaren gör avdrag för skattereduktion på priset för' +
      '                                 arbete (gäller inte material och resor) under punkterna D och G,' +
      ' enligt gällande lagstiftning.</label>' +
      '                              </div>' +
      '                           </td>' +
      '                           <td>' +
      '                              <div class="form-check form-check-inline">' +
      inlineCheckbox7 +
      '                                 <label class="form-check-label" for="inlineCheckbox7">Nej, inget ROT-avdrag ska göras.</label>' +
      '                              </div>' +
      '                           </td>' +
      '                        </tr>' +
      taxdeductionhtml +
      '                     </tbody>' +
      '                  </table>' +
      '               </div>' +
      '            </div>' +
      '      </div>' +
      pageFbreaklastprice +
      '      <!-- section F -->' +
      '      <div class="container">' +
      '        <div class="row border-secondary border-bottom mt-5">' +
      '          <h5  style="width:100%;">F. Tider</h5>' +
      '        </div>' +
      '        <div class="row mt-4">' +
      // tslint:disable-next-line:max-line-length
      '          <p>Arbete, enligt punkt B, ska påbörjas den <span class="text-secondary">' + this.formatDate(this.agreementCreate.startdate) + ' </span> och ska senast vara klart den <span class="text-secondary">'
      + this.formatDate(this.agreementCreate.enddate) + ' </span> Vid eventuella ändringar och tilläggsarbeten ska kontraktstiden ändras. Läs punkt 7 i de allmänna bestämmelserna.</p>' +
      '        </div>' +
      '      </div>' +
      pageGbreaklastprice +
      '      <!-- section G -->' +
      '      <div class="container">' +
      '        <div class="row border-secondary border-bottom mt-5">' +
      '          <h5  style="width:100%;">G. Ändringar och tilläggsarbeten</h5>' +
      '        </div>' +
      '        <div class="row mt-4">' +
      // tslint:disable-next-line:max-line-length
      '          <p>Ändringar och tilläggsarbeten debiteras antingen till fast pris eller på löpande räkning. Vid arbete på löpande räkning debiteras kostnaden enligt följande:</p>' +
      '        </div>' +
      '        <div class="row mt-2">' +
      // tslint:disable-next-line:max-line-length
      '          <p>Arbete <span class="text-secondary">' + this.formatPriceValuesPDF(this.agreementCreate.hourlyPriceadditionalwork) + ' </span> kr/tim inklusive entreprenörarvode och moms</p>' +
      '        </div>' +
      '        <div class="row mt-2">' +
      // tslint:disable-next-line:max-line-length
      '          <p>Arbetsledning <span class="text-secondary"> ' + this.formatPriceValuesPDF(this.agreementCreate.hourlyPriceadditionalworkManage) + ' </span> kr/tim inklusive entreprenörarvode och moms</p>' +
      '        </div>'
      +
      // '        <div class="row mt-2">'+
      // tslint:disable-next-line:max-line-length
      // '          <p>Överenskomna underentreprenader debiteras med redovisad självkostnad med tillägg för entreprenörarvode om <span class="text-secondary">sample text </span> %. Moms tillkommer.'+
      // '          Material, varor, hjälpmedel och övriga kostnader debiteras med redovisad självkostnad med tillägg för entreprenörarvode om <span class="text-secondary">sample text </span>%.'+
      // '          Moms tillkommer.</p>'+
      // '        </div>' +
      // '        <div class="row mt-2">'+
      // '          <p>Resor debiteras enligt följande <span class="text-secondary">sample text sample text</span></p>'+
      // '        </div>' +
      // '        <div class="row mt-2">'+
      // tslint:disable-next-line:max-line-length
      // '          <p>Er överenskommelse om ändringar och tilläggsarbeten bör vara skriftlig och innehålla information om arbetets omfattning, om arbetet påverkar'+
      // '          kontraktstiden och övriga villkor. Använd gärna tillhörande <a href="https://www.omboende.se/Global/Bygga/Dokument/Kov_ATA_Andringarochtillaggsarbeten.pdf">blankett</a> för ändringar och tilläggsarbeten. </p>'+
      // '        </div>'
      // +
      '      </div>' +
      pageHbreaklastprice +
      '      <!-- section H -->' +
      '      <div class="container">' +
      '<div class="row border-secondary border-bottom mt-3">' +
      '               <h5  style="width:100%;">H. Betalning</h5>' +
      '               <p class="ml-3"  style="width:100%;">Läs punkt 11 i de allmänna bestämmelserna.</p>' +
      '            </div>' +
      '            <div class="row mt-4">' +
      '               <div class="table-responsive" style="overflow-x: hidden;overflow-y: hidden">' +
      '                  <table class="table table-bordered">' +
      '                     <tbody>' +
      '                        <tr>' +
      '                           <td >' +
      '                              <div class="form-check form-check-inline" ' +
      ' style="display: -webkit-inline-box;-webkit-box-align: center;">' +
      inlineCheckbox14
      +
      '                                 <label class="form-check-label"' +
      ' for="inlineCheckbox14" style="width:100%;display: block;margin-left: 10px;">' +
      'Ändringar- och tilläggsarbeten ska betalas mot faktura allt eftersom de utförs, om ni inte avtalar om' +
      '                                 annat.</label>' +
      '                              </div>' +
      '                           </td>' +
      '                        </tr>' +
      '                        <tr>' +
      '                           <td>' +
      '                              <div class="form-check form-check-inline" '
      + ' style="display: -webkit-inline-box;-webkit-box-align: center;">' +
      inlineCheckbox15 +
      '                                 <label class="form-check-label"' +
      ' for="inlineCheckbox15"  style="width:100%;display: block;margin-left: 10px;">Hela beloppet betalas när arbetet är utfört.</label>' +
      '                              </div>' +
      '                           </td>' +
      '                        </tr>' +
      '                        <tr>' +
      '                           <td>' +
      '                              <div class="form-check form-check-inline" '
      + ' style="display: -webkit-inline-box;-webkit-box-align: center;">' +
      inlineCheckbox16 +
      '                                 <label class="form-check-label" ' +
      ' for="inlineCheckbox16"  style="width:100%;display: block;margin-left: 10px;">Betalning sker enligt betalningsplan.</label>' +
      '                              </div>' +
      '                           </td>' +
      '                        </tr>' +
      '                        <tr>' +
      '                           <td>' +
      '                              <div class="form-check form-check-inline" ' +
      ' style="display: -webkit-inline-box;-webkit-box-align: center;">' +
      inlineCheckbox17 +
      // tslint:disable-next-line:max-line-length
      '                                 <label class="form-check-label" for="inlineCheckbox17" style="width:100%;display: block;margin-left: 10px;">Specifcerad faktura</label>' +
      '                              </div>' +
      '                           </td>' +
      '                        </tr>' +
      '                        <tr>' +
      '                           <td colspan="2">' +
      'Om ni inte har avtalat om något annat gäller följande:' +
      '                              <ul>' +
      '                                 <li>De arbeten som anges i fakturan ska vara utförda när fakturering sker.</li>' +
      '                                 <li>Fakturan ska betalas inom en månad efter att beställaren mottagit den. </li>' +
      '                                 <li>Om betalningen inte sker inom rätt ' +
      ' tid ska beställaren betala dröjsmålsränta enligt räntelagen.</li>' +
      '                              </ul>' +
      '                           </td>' +
      '                        </tr>' +
      '                     </tbody>' +
      '                  </table>' +
      '               </div>' +
      '            </div>' +
      '      </div>'
      +
      '      <!-- section I -->' +

      '      <div class="container">' +
      '        <div class="row border-secondary border-bottom mt-5">' +
      '          <h5  style="width:100%;">I. Övriga överenskommelser</h5>' +
      '        </div>' +
      '        <div class="row mt-4">' +
      '               <div class="table-responsive">' +
      '                  <table class="table table-bordered">' +
      '                     <tbody>' +
      '                        <tr>' +
      '                           <td colspan="2">Förseningsvite, besiktning, garanti, försäkring, städning m.m.' +
      '<span class="pl-2 text-secondary">' + this.agreementCreate.additionalagreement + '</span>' +
      '                           </td>' +
      '                        </tr>' +
      '                     </tbody>' +
      '                  </table>' +
      '</div>' +
      ' </div>' +
      ' </div>'
      +
      // pageJbreaklastprice +
      // '      <!-- section J -->' +
      // '<div class="container">' +
      // ' <div class="row border-secondary border-bottom mt-3">' +
      // '               <h5>Offertsammanställning</h5>' +
      // '            </div>' +
      // '            <div class="row mt-4">' +
      // '               <div class="table-responsive" style="overflow-x: hidden;overflow-y: hidden">' +
      // '                  <table class="table table-bordered">' +
      // '                     <tbody>' +
      // totalPriceDefine
      // +
      // '                        <tr>' +
      // '                           <td colspan="2">Project start date' +
      // '                              <span class="pl-2 text-secondary">' +
      // this.formatDate(this.agreementCreate.startdate) + '</span>' +
      // '                           </td>' +
      // '                        </tr>' +
      // '                        <tr>' +
      // '                           <td colspan="2">Project end date' +
      // '                              <span class="pl-2 text-secondary">'
      // + this.formatDate(this.agreementCreate.enddate) + '</span>' +
      // '                           </td>' +
      // '                        </tr>' +
      // '                        <tr>' +
      // '                           <td colspan="2">Offer expiry date' +
      // '                              <span class="pl-2 text-secondary">'
      // + this.formatDate(this.agreementCreate.offerExpirydate) + '</span>' +
      // '                           </td>' +
      // '                        </tr>' +
      // '                     </tbody>' +
      // '                  </table>' +
      // '               </div>' +
      // '            </div>' +
      // '</div>' +
      pagebreaklastprice +
      '<div class="container">' +
      '        <div class="row border-secondary border-bottom mt-5">' +
      '          <h5  style="width:100%;">Signering</h5>' +
      '        </div>' +
      '<div class="row mt-4">' +
      ' <table class="table table-bordered">' +
      '                     <tbody>' +
      '                        <tr>' +
      '                           <td height="70">Underskrift hantverkare (näringsidkare) <br/>' +
      '                           </td>' +
      '                           <td>Underskrift beställare (konsument) <br/>' +
      '                           </td>' +
      '                        </tr>' +
      '                        <tr>' +
      '                           <td height="70">Namnförtydligande <br/>' +
      '                           </td>' +
      '                           <td> Namnförtydligande<br/>' +
      '                           </td>' +
      '                        </tr>' +
      '                        <tr>' +
      '                           <td height="70"> Stad / Datum <br/>' +
      '                           </td>' +
      '                           <td height="70"> Stad / Datum <br/>' +
      '                           </td>' +
      '                        </tr>' +
      '                     </tbody>' +
      '                  </table>' +
      '</div>' + '' +
      '</div>'
      +
      pagebreakfirsttwo +
      '      <div class="container">' +
      '        <div class="row mt-5">' +
      '          <h6 class="font-weight-bold">Allmänna bestämmelser för Hantverkarformuläret 17</h6> </div>' +
      // tslint:disable-next-line:max-line-length
      ' <div class="row"><small>Dessa allmänna bestämmelser är framtagna av Konsumentverket, Villaägarnas Riksförbund och Sveriges Byggindustrier och avsedda att användas tillsammans med Hantverkarformuläret 17. Vid uppförande av' +
      'eller tillbyggnad till småhus bör istället allmänna bestämmelser för småhusentreprenader ABS användas.</small>' +
      '        </div>' +
      '        <div class="row mt-4">' +
      '          <div class="col pr-4">' +
      '            <small>' +
      '              <ol class="pl-0">' +
      '                <li class="font-weight-bold">Tillämplighet' +
      '<p class="font-weight-normal">För entreprenaden gäller konsumenttjänstlagen (1985:716) och vad som föreskrivs nedan i dessa' +
      '                  bestämmelser. Vissa paragrafer i konsumenttjänstlagen återges i grå rutor</p>' +
      '                </li>' +
      '                <li class="font-weight-bold"> Arbetets utförande' +
      // tslint:disable-next-line:max-line-length
      '                  <p class="font-weight-normal">Hantverkaren ska utföra arbetet fackmässigt. Hantverkaren ska också med tillbörlig omsorg ta till vara' +
      '                  beställarens intressen och samråda med beställaren i den utsträckning det behövs och är möjligt,' +
      '                  t.ex. om det under arbetets gång visar sig att tjänsten inte är till rimlig nytta för beställaren eller om' +
      '                  kostnaden blir betydligt högre än beställaren räknat med. Hantverkaren kan vid tilläggsarbeten ha rätt' +
      '                  till pristillägg enligt punkt 6. <br>' +
      '                  Behövs intrimningsåtgärder efter arbetets avslutande åtar sig hantverkaren att inom skälig tid och,' +
      '                  om inte annat avtalats, utan särskild kostnad utföra åtgärderna. Behov av sådana åtgärder är inte att' +
      '                  betrakta som avvikelser från ett fackmässigt utförande.</p>' +
      '                </li>' +
      '                <li class="font-weight-bold"> Ritningar m.m.' +
      '                  <p class="font-weight-normal">' +
      '                  Alla ritningar och tekniska handlingar som hantverkaren överlämnat till beställaren förblir hantverkarens' +
      '                  egendom och får inte i ett illojalt syfte delges eller överlämnas till utomstående. Bilagor till anbud,' +
      '                  som inte antas, ska återlämnas till hantverkaren.</p>' +
      '                </li>' +
      '                <li class="font-weight-bold"> Tillträde ? iordningställande' +
      '                  <p class="font-weight-normal">' +
      '                  Beställaren ska lämna hantverkaren erforderligt tillträde samt genom att fytta bohag och andra' +
      '                  föremål, se till att arbetsplatsen är i ett sådant skick att arbetet kan utföras.</p>' +
      '                </li>' +
      '                <li class="font-weight-bold">  Arbetets avbrytande m.m.' +
      '                  <p class="font-weight-normal">' +
      '                  Om det sedan arbetet har påbörjats visar sig att det inte kan anses vara till rimlig nytta för beställaren' +
      '                  eller att priset för arbetet kan bli betydligt högre än beställaren hade kunnat räkna med, ska hantverkaren' +
      '                  underrätta beställaren om förhållandet och begära beställarens anvisningar.<br>' +
      '                  Kan beställaren inte anträffas eller lämnar beställaren av annan orsak inte anvisningar till hantverkaren' +
      '                  inom rimlig tid ska arbetet avbrytas. Detta gäller dock ej om det fnns särskilda skäl att anta att' +
      '                  beställaren ändå önskar få arbetet utfört.<br>' +
      '                  Avbryter hantverkaren ett påbörjat arbete med stöd av andra stycket har hantverkaren rätt till ersättning' +
      '                  för extra kostnader. Medför avbrottet en väsentlig olägenhet för hantverkaren får hantverkaren,' +
      '                  under de förutsättningar som anges i konsumenttjänstlagen, häva avtalet.</p>' +
      '                </li>' +
      '                <li class="font-weight-bold"> Ändringar, tilläggsarbeten och pristillägg' +
      '                  <p class="font-weight-normal">' +
      '                  Om det, när arbetet utförs, framkommer behov av arbete, som på grund av sambandet med det beställda' +
      '                  arbetet lämpligen bör utföras samtidigt med detta (tilläggsarbete) ska hantverkaren underrätta' +
      '                  beställaren och begära beställarens anvisningar.<br>' +
      '                  Med tilläggsarbeten enligt föregående stycke likställs arbete som föranleds av att uppgifter m.m.' +
      '                  som beställaren svarar för inte är riktiga, att arbetsområdet eller andra förhållanden av betydelse' +
      '                  avviker från vad hantverkaren haft rätt att förutsätta, eller att förhållandena i övrigt inte är sådana' +
      '                  som de kunnat antas vara vid en fackmässig bedömning.<br>' +
      '                  Kan beställaren inte anträffas eller lämnar beställaren inte anvisningar inom rimlig tid får hantverkaren' +
      '                  utföra tilläggsarbetet<br>' +
      '                  ? om kostnaderna för tilläggsarbetet inte överstiger 15 % av kostnaderna för det beställda arbetet eller' +
      '                  ?om det fnns särskilda skäl att anta att beställaren önskar tilläggsarbetet utfört i samband med det' +
      '                  beställda arbetet.<br>' +
      '                  Hantverkaren är skyldig att utföra tilläggsarbeten som inte kan skjutas upp utan fara för allvarlig' +
      '                  skada för beställaren, om beställarens anvisningar inte kan inhämtas eller om beställaren begär det.' +
      '                  Har hantverkaren utfört tilläggsarbeten enligt denna punkt eller har arbetet fördyrats på grund av' +
      '                  omständigheter som är att hänföra till beställaren och som hantverkaren inte borde ha förutsett när' +
      '                  avtalet ingicks har hantverkaren rätt till pristillägg.</p>' +
      '                  <div class="card bg-light border-0">' +
      '                    <div class="px-2">' +
      '                      <p class="font-weight-bold m-0">Påföljder vid fel</p>' +
      // tslint:disable-next-line:max-line-length
      '                      <p class="font-weight-normal m-0">16 § Är tjänsten felaktig utan att det beror på något förhållande på konsumentens sida, får konsumenten' +
      '                      hålla inne betalningen enligt 19 §. Han får vidare kräva att felet avhjälps enligt 20 § första stycket' +
      '                      eller också göra avdrag på priset eller häva avtalet enligt 21 §.<br>' +
      '                      Dessutom får konsumenten kräva skadestånd av näringsidkaren enligt vad som sägs i 31 §.</p>' +
      '                    </div>' +
      '                  </div>' +
      '                  <br>' +
      '                  <div class="card bg-light border-0">' +
      '                    <div class="px-2">' +
      '                      <p class="font-weight-bold m-0">Avhjälpande</p>' +
      // tslint:disable-next-line:max-line-length
      '                      <p class="font-weight-normal m-0">20 § Konsumenten har rätt att kräva att näringsidkaren avhjälper felet, om det inte medför olägenheter' +
      '                      eller kostnader för näringsidkaren som är oskäligt stora i förhållande till felets betydelse för konsumenten. <br>' +
      '                      Även om konsumenten inte kräver det får näringsidkaren avhjälpa felet, om han efter det att reklamation' +
      '                      har kommit honom tillhanda utan uppskov erbjuder sig att göra detta och konsumenten inte har' +
      '                      något särskilt skäl att avvisa erbjudandet. <br>' +
      '                      Avhjälpande skall ske inom skälig tid efter det att konsumenten har gett näringsidkaren tillfälle till' +
      '                      det.<br>' +
      '                      Avhjälpande skall ske utan kostnad för konsumenten. Detta gäller dock inte kostnader som skulle ha' +
      '                      uppkommit även om tjänsten hade utförts felfritt eller, om felet beror på en olyckshändelse eller därmed' +
      '                      jämförlig händelse, kostnader för att ersätta material som konsumenten enligt avtalet om tjänsten har' +
      '                      tillhandahållit och bekostat. </p>' +
      '                    </div>' +
      '                  </div>' +
      '                </li>' +
      '                <li class="font-weight-bold mt-3">  Hantverkarens rätt till tidsförlängning m.m.' +
      '                  <p class="font-weight-normal">' +
      '                    Kontraktsarbetena ska vara färdigställda och tillgängliga för slutbesiktning vid kontraktstidens utgång.' +
      '                    Kontraktstiden ska förlängas eller avkortas i den utsträckning ändringar och tilläggsarbeten föranleder' +
      '                    ökad eller minskad tidsåtgång. <br>' +
      '                    Om någon tid för färdigställande inte har avtalats, ska entreprenaden vara färdigställd inom den' +
      '                    tid som är skälig med hänsyn till särskilt vad som är normalt för en entreprenad av samma art och' +
      '                    omfattning. Intrimning, justering eller provning som ingår i entreprenaden ska vara fullgjord inom' +
      '                    entreprenadtiden om inte lämplig årstid eller entreprenadens ibruktagande bör avvaktas.<br>' +
      '                    Hantverkaren har rätt till erforderlig förlängning av kontraktstiden, om hantverkaren hindras att' +
      '                    färdigställa kontraktsarbetena inom kontraktstiden på grund av omständigheter utanför hantverkarens' +
      '                    kontroll som hantverkaren inte skäligen kunde ha förväntas ha räknat med vid avtalets ingående samt' +
      '                    att hantverkaren inte heller skäligen kunde ha undvikit eller övervunnit dess menliga inverkan.<br>' +
      '                    Part ska utan dröjsmål underrätta motparten om förhållande som parten insett eller borde ha insett' +
      '                    skulle medföra försening. Om part underlåter att lämna sådan underrättelse, får parten inte åberopa' +
      '                    förhållandet annat än om motparten insett eller borde ha insett detsamma.<br>' +
      '                  </p>' +
      '                </li>' +
      '              </ol>' +
      '            </small>' +
      '          </div>' +
      '          <div class="col pr-0">' +
      '            <small>' +
      // tslint:disable-next-line:max-line-length
      '              <p class="font-weight-normal">Dröjsmål på hantverkarens sida föreligger om hantverkaren överskrider kontraktstiden eller den ändrade' +
      '              tid för färdigställande som ska gälla enligt ovan.<br>' +
      '              Dröjsmål på hantverkarens sida föreligger också, om hantverkaren inte iakttar en överenskommen' +
      '              tid för påbörjande av kontraktsarbetena eller för ett arbetes framskridande, under förutsättning att' +
      '              hantverkaren inte har rätt till tidsförlängning enligt ovan.</p>' +
      '              <div class="card bg-light border-0">' +
      '                <div class="px-2">' +
      '                  <p class="font-weight-bold m-0">Påföljder vid dröjsmål</p>' +
      // tslint:disable-next-line:max-line-length
      '                  <p class="font-weight-normal m-0">25 § Vid dröjsmål på näringsidkarens sida får konsumenten hålla inne betalningen enligt 27 §. Han' +
      '                  får välja mellan att kräva att näringsidkaren utför tjänsten enligt 28 § och att häva avtalet enligt 29 §.' +
      '                  Dessutom får konsumenten kräva skadestånd av näringsidkaren enligt vad som sägs i 31 §.</p>' +
      '                </div>' +
      '              </div>' +
      '              <br>' +
      '              <div class="card bg-light border-0">' +
      '                <div class="px-2">' +
      '                  <p class="font-weight-bold m-0">Reklamation vid fel och dröjsmål</p>' +
      // tslint:disable-next-line:max-line-length
      '                  <p class="font-weight-normal m-0">17 § 1 st. Vill konsumenten åberopa att tjänsten är felaktig, skall han underrätta näringsidkaren om' +
      '                  detta inom skälig tid efter det att han märkt eller borde ha märkt felet (reklamation). Underrättelse som' +
      '                  sker inom två månader efter det att konsumenten märkt felet skall alltid anses ha skett i rätt tid. Reklamation' +
      '                  får dock inte ske senare än tre år eller, i fråga om arbete på mark eller på byggnader eller andra' +
      '                  anläggningar på mark eller i vatten eller på andra fasta saker, tio år efter det att uppdraget avslutades,' +
      '                  såvida inte annat följer av en garanti eller liknande utfästelse.<br><br>' +
      '                  26 § 1 st. Har uppdraget avslutats, får konsumenten häva avtalet eller fordra skadestånd på grund av' +
      '                  ett dröjsmål endast under förutsättning att han senast inom skälig tid efter uppdragets avslutande har' +
      '                  underrättat näringsidkaren om att han vill åberopa dröjsmålet (reklamation).' +
      '                  </p>' +
      '                </div>' +
      '              </div>' +
      '              <ol start="8" class="pl-0">' +
      '                <li class="font-weight-bold">Besiktning' +
      // tslint:disable-next-line:max-line-length
      '                  <p class="font-weight-normal">Har avtal träffats om slutbesiktning ska hantverkaren underrätta beställaren om när sådan besiktning' +
      '                  kan ske.<br>' +
      '                  Beställaren eller hantverkaren får begära<br>' +
      '                  ? garantibesiktning om garantitid har avtalats, garantibesiktningen hålls före garantitidens utgång,<br>' +
      '                  ? efterbesiktning av arbete som utförts för att avhjälpa fel.<br>' +
      '                  Beställaren utser en opartisk besiktningsman som i god tid kallar parterna till besiktning.<br>' +
      '                  Beställaren står kostnaden för slutbesiktning och garantibesiktning. Kostnaden för efterbesiktning<br>' +
      '                  betalas av hantverkaren om fel kvarstår och i annat fall av beställaren.<br>' +
      '                  Besiktningsmannen ska upprätta ett utlåtande över en utförd besiktning.</p>' +
      '                </li>' +
      '                <li class="font-weight-bold">Skadestånd' +
      // tslint:disable-next-line:max-line-length
      '                  <p class="font-weight-normal">I enlighet med förutsättningarna i konsumenttjänstlagen har beställaren rätt till ersättning för skadat .ex. utgifter och förluster ? som orsakats honom genom fel eller dröjsmål. Hantverkaren ska också,' +
      '                  under de förutsättningar som anges i konsumenttjänstlagen, ersätta skada på beställarens egendom,' +
      '                  som inträffat då egendomen varit under hantverkarens kontroll. Skadestånd omfattar dock inte ersättning' +
      '                  för förlust i näringsverksamhet. <br>' +
      '                  Beställaren ska så långt det är möjligt vidta åtgärder för att begränsa verkningarna av skadan.' +
      '                  Personskador regleras inte av dessa bestämmelser.</p>' +
      '                </li>' +
      '                <li class="font-weight-bold"> Ungefärlig prisuppgift' +
      // tslint:disable-next-line:max-line-length
      '                  <p class="font-weight-normal">En ungefärlig prisuppgift omfattar endast de arbeten och åtaganden som anges under rubriken Omfattning' +
      '                  i Hantverkarformuläret ?17. Priset får inte överskrida den ungefärliga prisuppgiften med mer' +
      '                  än 15 %, om inte hantverkaren har rätt till ersättning utöver kontraktssumman enligt dessa allmänna' +
      '                  bestämmelser eller konsumenttjänstlagen. <br>' +
      '                  Till den del det ungefärliga priset avser markarbeten, rivningsarbeten eller annat som kräver undersökningar' +
      '                  som hantverkaren normalt inte är skyldig att utföra i anbudsskedet, ska prisgränsen enligt' +
      '                  föregående stycke i stället vara 25 %.</p>' +
      '                </li>' +
      '                <li class="font-weight-bold"> ROT-avdrag' +
      // tslint:disable-next-line:max-line-length
      '                  <p class="font-weight-normal">Vid ROT-avdrag gäller följande. Beställaren är skyldig att på begäran uppvisa ett intyg från Skatteverket' +
      '                  som visar hur mycket skattereduktion som beställaren utnyttjat under året. <br>' +
      '                  Beställaren är skyldig att betala återstående arbetskostnad till hantverkaren om Skatteverket helt' +
      // tslint:disable-next-line:max-line-length
      '                  eller delvis inte medger utbetalning efter hantverkarens ansökan eller återkräver redan utbetalt skattereduktionsbelopp.' +
      '                  Detta gäller inte om skälet för att utbetalningen inte medges eller återkrävs beror på' +
      '                  någon omständighet som hantverkaren är ansvarig för.<br>' +
      '                  Betalning av återstående arbetskostnad ska ske inom 10 dagar från den dag hantverkaren framställt' +
      '                  krav. Därefter löper dröjsmålsränta enligt räntelagen.<br>' +
      '                  Beställaren försäkrar att beställaren är ägare/innehavare av angiven fastighet/bostadsrätt/ägarlä-' +
      '                  genhet, samt att beställaren nyttjar densamma.</p>' +
      '                </li>' +
      '                <li class="font-weight-bold"> Beställarens avbeställningsrätt' +
      // tslint:disable-next-line:max-line-length
      '                  <p class="font-weight-normal">Beställaren har rätt att avbeställa arbetet innan det avslutas mot ersättning till hantverkaren enligt' +
      '                  konsumenttjänstlagens bestämmelser. </p>' +
      '                  <div class="card bg-light border-0">' +
      '                    <div class="px-2">' +
      '                      <p class="font-weight-bold m-0">Näringsidkarens rätt att inställa arbetet</p>' +
      // tslint:disable-next-line:max-line-length
      '                      <p class="font-weight-normal m-0">45 § Skall betalning enligt avtalet ske helt eller delvis innan tjänsten har utförts och betalar inte konsumenten' +
      '                      i rätt tid, får näringsidkaren inställa arbetet till dess att konsumenten betalar. Om det följer' +
      '                      av avtalet att konsumenten skall medverka till tjänstens utförande och han inte i rätt tid lämnar sådan' +
      '                      medverkan som utgör en väsentlig förutsättning för utförandet, får näringsidkaren inställa arbetet till' +
      '                      dess att konsumenten lämnar sin medverkan. <br>' +
      '                      Har tjänsten påbörjats, är näringsidkaren dock skyldig att såvitt möjligt utföra arbete som inte kan' +
      '                      uppskjutas utan risk för allvarlig skada för konsumenten, om inte arbetet medför väsentliga kostnader' +
      '                      eller olägenheter för näringsidkaren. <br>' +
      '                      Inställer näringsidkaren arbetet enligt första stycket, har han rätt till ersättning för kostnader och' +
      '                      andra förluster som detta åsamkar honom, om konsumenten inte visar att dröjsmålet ej beror på' +
      '                      försummelse på hans sida.' +
      '                      </p>' +
      '                    </div>' +
      '                  </div>' +
      '                </li>' +
      '                <li class="font-weight-bold mt-3">  Hantverkarens försäkringar' +
      // tslint:disable-next-line:max-line-length
      '                  <p class="font-weight-normal">Hantverkaren ska ha allriskförsäkring för skador på entreprenaden. Beställaren ska vara medförsäkrad. <br>' +
      '                  Hantverkaren ska vidare ha ansvarsförsäkring för entreprenadverksamhet under entreprenadtiden' +
      '                  och under två år efter entreprenadens godkännande.</p>' +
      '                </li>' +
      '                <li class="font-weight-bold"> Tvist' +
      // tslint:disable-next-line:max-line-length
      '                  <p class="font-weight-normal">Tvist avgörs av allmän domstol. Beställaren (konsumenten) kan också anmäla tvister till Allmänna' +
      '                  reklamationsnämnden (www.arn.se), Box 174, 101 23 Stockholm. Konsumenter kan även få vägledning' +
      '                  av hemkommunens konsumentvägledare eller Hallå konsument. </p>' +
      '                </li>' +
      '              </ol>' +
      '            </small>' +
      '          </div>' +
      '        </div>' +
      '        </div>' +
      '        </div>' +
      this.getAttachmenthtmltag()
      +
      this.generatedbodyAttachment +
      '    </div>' +
      '    <!-- Optional JavaScript -->' +
      '    <!-- jQuery first, then Popper.js, then Bootstrap JS -->' +
      // tslint:disable-next-line:max-line-length
      '    <!-- <script src="https://code.jquery.com/jquery-3.2.1.slim.min.js" integrity="sha384-KJ3o2DKtIkvYIK3UENzmM7KCkRr/rE9/Qpg6aAZGJwFDMVNA/GpGFF93hXpG5KkN" crossorigin="anonymous"></script>' +
      // tslint:disable-next-line:max-line-length
      '    <script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.12.9/umd/popper.min.js" integrity="sha384-ApNbgh9B+Y1QKtv3Rn7W3mgPxhU9K/ScQsAP7hUibX39j7fakFPskvXusvfa0b4Q" crossorigin="anonymous"></script>' +
      '    <script src="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/js/bootstrap.min.js" integrity="sha384-JZR6Spejh4U02d8jOt6vLEHfe/JQGiRRSQQxSfFWpi1MquVdAyjUar5+76PVCmYl" crossorigin="anonymous"></script> -->' +
      '  </body>' +
      '</html>';

    // console.log(this.agreementhtmlstring);
    // tslint:disable-next-line:prefer-const
    let deifinevalue = false;
    if (this.tabIndentification === 'activeProjects') {
      deifinevalue = true;
    } else if (this.tabIndentification === 'activeRequests') {
      deifinevalue = false;
    } else if (this.tabIndentification === 'archive') {
      deifinevalue = false;
    }

    this.agreementCreate.yosso_fee = this.getYasoFeeCalculation();
    // tslint:disable-next-line:prefer-const
    let createBody = this.sellerService.getGenerateBodyPdf(this.agreementCreate, this.agreementhtmlstring, this.projectId,
      this.currentSellerId, this.latestBuyerId, true, deifinevalue, this.agreementparentId, draft);

    this.loaderActivate = true;
    this.sellerService.createAgreementPdf(createBody).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        if (draft === 1) {
          this.acceptedProjects[this.isActiveRequestIndex].is_draft = true;
          if (this.acceptedProjects[this.isActiveRequestIndex]['drafted_project_agreements_as_dict'] == null) {
            this.acceptedProjects[this.isActiveRequestIndex]['drafted_project_agreements_as_dict'] = {};
            this.acceptedProjects[this.isActiveRequestIndex]['drafted_project_agreements_as_dict']['updated_utc'] = new Date().toString();
          }else {
            this.acceptedProjects[this.isActiveRequestIndex]['drafted_project_agreements_as_dict']['updated_utc'] = new Date().toString();
          }
        }else {
          this.acceptedProjects[this.isActiveRequestIndex].is_draft = false;
          // this.acceptedProjects[this.isActiveRequestIndex]['drafted_project_agreements_as_dict']['updated_utc'] = new Date().toString();
        }
        this.closeMainAgreementModalByHidden.nativeElement.click();
        this.activeStep = 1;
        this.getAgreementFilePath(this.projectId, this.currentSellerId);
      }
    }, err => {
      console.log(err);
    });

  }

  onFileChange(event, uploadfiletype: string) {
    // tslint:disable-next-line:prefer-const
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      for (let index = 0; index < event.target.files.length; index++) {
        // tslint:disable-next-line:prefer-const
        let file = event.target.files[index];
        this.loaderActivate = true;
        this.sellerService.uploadagreementbrowsefile(this.projectId, file).finally(() => {
          this.loaderActivate = false;
        }).subscribe(res => {
          if (res != null) {
            this.agreementCreate.uploaded_links.push(res);
          }
        }, err => {
          console.log(err);
        });
      }
    }
  }


  // Generate the Attachments
  getAttachmenthtmltag() {
    // tslint:disable-next-line:prefer-const
    let body = '';
    if (this.agreementCreate.uploaded_links.length > 0) {
      this.agreementCreate.uploaded_links.forEach(element => {
        body = body + '<tr>' +
          '<td colspan="1">' +
          '  <img src="' + element + '" style="height:400px" />' +
          '</td>' +
          '</tr>';
      });

      // tslint:disable-next-line:prefer-const
      let myvar = '<div style="page-break-before:always"> </div><div class="container">' +
        ' <div class="row border-secondary border-bottom">' +
        '               <h4>Appendix</h4>' +
        '            </div>' +
        '<div class="row mt-5">' +
        '                <div class="table-responsive">' +
        '                    <table class="table table-bordered">' +
        '                        <tbody>' +
        '                            <tr>' +
        '                                <td>' +
        'Arbetsbeskrivning' +
        '                                </td>' +
        '                            </tr>' +
        '                                   ' +
        body +
        '                                   ' +
        '                        </tbody>' +
        '                    </table>' +
        '                </div>' +
        '            </div>' +
        '    </div>' +
        '<div style="page-break-before:always"> </div>';

      return myvar;
    } else {
      if (this.attachmentBottom) {
        // tslint:disable-next-line:prefer-const
        let myvar = '<div style="page-break-before:always"> </div><div class="container">' +
          ' <div class="row border-secondary border-bottom">' +
          '               <h4>Appendix</h4>' +
          '            </div>' +
          '    </div>' +
          '<div style="page-break-before:always"> </div>';
        return myvar;
      } else {
        return '';
      }
    }

  }

  formatDate(date) {
    if (date === undefined || date === null) {
      return '-';
    }
    // tslint:disable-next-line:prefer-const
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      // tslint:disable-next-line:prefer-const
      year = d.getFullYear();

    // tslint:disable-next-line:curly
    if (month.length < 2) month = '0' + month;
    // tslint:disable-next-line:curly
    if (day.length < 2) day = '0' + day;

    return [month, day, year].join('/');
  }

  // Call the Cancel uploaded images in Step 2 section
  removebrowseAttachFiles(i): void {
    this.agreementCreate.uploaded_links.splice(i, 1);
  }

  // Get Agreement File Path
  getAgreementFilePath(projectid: number, sellerid: number): void {
    this.latestAgreementInfo = {};
    this.sellerService.getAgreementFilePath(projectid, sellerid).subscribe(res => {
      if (res != null) {
        this.agreementFiles = res;
        if (this.agreementFiles.length > 0) {
          this.agreementparentId = this.agreementFiles[0].project_agreement_id;
          this.latestAgreementInfo = this.agreementFiles[0];
          this.agreementfilename = this.agreementFiles[0].project_agreement_file_path;
        }
      }
    }, err => {
      console.log(err);
    });
  }

  // get Buyer Information
  getBuyerInformation(buyerid: number): void {
    if (buyerid != null) {
      this.sellerService.getBuyerInformationByBuyerId(buyerid.toString()).subscribe(res => {
        this.currentBuyerInformation = res;
        this.agreementCreate.nameperson1 = res.first_name + ' ' + res.last_name;
        this.agreementCreate.identitynumberperson1 = res.bank_id;
        this.agreementCreate.firstStepemail = res.email;
        if (res.address != null) {
          this.agreementCreate.firstStepAddress = res.address;
          this.agreementCreate.buyeraddressservicetakeplace = res.address;
        }

        this.changeAgreementObject.nameperson1 = res.first_name + ' ' + res.last_name;
        this.changeAgreementObject.firstStepemail = res.email;
        this.changeAgreementObject.identitynumberperson1 = res.bank_id;
        if (res.address != null) {
          this.changeAgreementObject.firstStepAddress = res.address;
        }

      }, err => {
        console.log(err);
      });
    }
  }

  // get the Internally Created Project Information
  getInternallyCreatedBuyerInformation(projectId) {
    this.sellerService.getInformationInternallyCreatedProject(projectId.toString()).subscribe(res => {
      this.internalCreatedProjectInformation = res;
     // console.log(res);
    }, err => {
      console.log(err);
    });
  }


  getYasoFeeCalculation(): number {
    let yasoofee = 0;
    if (this.agreementCreate.priceOption1 === 'Fast pris') {
      if (this.agreementCreate.isTotalFastPrice) {
        yasoofee = this.formatPriceValues(this.agreementCreate.fastpriceTotal) * 0.03;
      } else {
        yasoofee = ( this.formatPriceValues(this.agreementCreate.fastpriceArbete) +
        this.formatPriceValues(this.agreementCreate.fastpriceMaterial) +
          this.formatPriceValues(this.agreementCreate.fastpriceResor)) * 0.03;
      }

      if (yasoofee > 500) {
        if (yasoofee > 3000) {
          return 3000;
        }
        return yasoofee;
      } else {
        return 500;
      }
    } else if (this.agreementCreate.priceOption2 === 'Ungefärlig prisuppgift') {
      yasoofee = this.formatPriceValues(this.agreementCreate.ungefarligprisuppgift) * 0.03;
      if (yasoofee > 500) {
        if (yasoofee > 3000) {
          return 3000;
        }
        return yasoofee;
      } else {
        return 500;
      }
    } else if (this.agreementCreate.priceOption3 === 'Löpande räkning​') {
      return 999;
    }

  }

  // attach file by drop file into drop zone
  public agreementFileByDrop(event: UploadEvent) {
    this.agreementFileData = [];
    this.uploadErrorMessage = '';
    if (event.files && event.files[0]) {
      const fileEntry = event.files[0].fileEntry as FileSystemFileEntry;
      fileEntry.file((file: File) => {
        if (file) {
          // tslint:disable-next-line:prefer-const
          let extension = file.name.split('.').splice(-1)[0].toLocaleLowerCase();
          // tslint:disable-next-line:prefer-const
          let typefile = this.sellerService.getMainFileType(extension);
          if (typefile !== 'pdf') {
            this.translate.get('SafetyBox.PdfFormatMessage').subscribe(res => {
              this.uploadErrorMessage = res;
            });
            return;
          }
          this.agreementFileData.push(file);
        }
      });
    }
  }
  // attach file by upload button click
  public attachagreementFileByInputClick(event) {
    this.uploadErrorMessage = '';
    if (event.target.files && event.target.files[0]) {
      // tslint:disable-next-line:prefer-const
      let extension = event.target.files[0].name.split('.').splice(-1)[0].toLocaleLowerCase();
      // tslint:disable-next-line:prefer-const
      let typefile = this.sellerService.getMainFileType(extension);
      if (typefile !== 'pdf') {
        this.translate.get('SafetyBox.PdfFormatMessage').subscribe(res => {
          this.uploadErrorMessage = res;
        });
        return;
      }
      this.agreementFileData.push(event.target.files[0]);
    }
  }

  // Call the Agreement Pdf Upload for Active Requests Projects
  uploadAgreementByPdfUpload(model: any, isValid: boolean) {
    this.uploadErrorMessage = '';
    if (!isValid) {
      return;
    }
    if (this.agreementFileData.length === 0) {
      this.translate.get('SafetyBox.PdfFormatMessage').subscribe(res => {
        this.uploadErrorMessage = res;
      });
      return;
    }

    const safety_box_link = environment.buyerendlink
      + '/buyer/safetybox?requestto=safetybox&requesttype=activerequest&selectedtab=agreement&sellerid=' + this.currentSellerId
      + '&projectid=';
    this.loaderActivate = true;
    this.sellerService.uploadAgreementBySeller(this.projectId, this.currentSellerId,
      this.latestBuyerId, model.startdate, model.enddate, model.offerExpirydate, model.total_price,
      this.agreementFileData[0], safety_box_link).finally(() => {
        this.loaderActivate = false;
      }).subscribe(res => {
        if (res != null) {
          this.closeuploadOfferModal.nativeElement.click();
          this.activeStep = 1;
          this.getAgreementFilePath(this.projectId, this.currentSellerId);
        }
      }, err => {
        console.log(err);
      });
  }

  // Call Agrement Information
  callagreementInformation(agreementid: number, is_additional_agreement) {
    this.agreementparentId = agreementid;
    this.loaderActivate = true;
    this.sellerService.getAgreementInfomrationByagreementId(agreementid, is_additional_agreement).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.setValueForAgreementCreateObj(res);
      }
    }, err => {
      console.log(err);
    });
  }

  resetToNewVersionCreateAgreement() {
    this.attachmentBottom = false;
    this.activateFistStepValidation = false;
    this.activateSecondStepValidation = true;
    this.activateLastStepValidation = false;
    this.activeStep = 1;
    this.agreementCreate = new AgreementCreateObj();
    this.agreementCreate.priceOption1 = 'Fast pris';

    this.agreementCreate.sellername = this.currentSellerInformation.first_name;
    this.agreementCreate.sellerorganization = this.currentSellerInformation.company_name;
    this.agreementCreate.selleremail = this.currentSellerInformation.seller_email;
    this.agreementCreate.sellerphonenumber = this.currentSellerInformation.contact_no;
    this.agreementCreate.sellerAddress = this.currentSellerInformation.address;
    this.agreementCreate.sellerregistredNumber = this.currentSellerInformation.company_registration_no;
    // if (this.currentSellerInformation.address != null) {
    //   this.agreementCreate.sellerAddress = this.currentSellerInformation.address.split(',')[0] + ', '
    //     + this.currentSellerInformation.address.split(',')[1] + ', '
    //     + this.currentSellerInformation.address.split(',')[2];
    // }
    this.agreementCreate.sellerregistredforTax = 'Yes';
    this.agreementCreate.buyerworkdescription = this.projectDetails.overview;

    this.agreementCreate.nameperson1 = this.currentBuyerInformation.first_name + ' ' + this.currentBuyerInformation.last_name;
    this.agreementCreate.firstStepemail = this.currentBuyerInformation.email;
    this.agreementCreate.identitynumberperson1 = this.currentBuyerInformation.bank_id;
    if (this.currentBuyerInformation.address != null) {
      this.agreementCreate.firstStepAddress = this.currentBuyerInformation.address;
      this.agreementCreate.buyeraddressservicetakeplace = this.currentBuyerInformation.address;
    }
    this.agreementparentId = null;
    if (Array.isArray(this.commonComponent.uploaded_links)) {
      this.agreementCreate.uploaded_links = this.commonComponent.uploaded_links;
    } else {
      if (this.commonComponent.scope_upload_links !== '[]') {
        this.agreementCreate.uploaded_links = String(this.commonComponent.uploaded_links).split(',');
      }
    }

  }

  resetToNewVersionUploadAgreement() {
    this.activeuploadStep.resetForm();
    this.uploadagreement = {};
    this.agreementFileData = [];
    this.uploadErrorMessage = '';
  }


  setValueForAgreementCreateObj(agreeementObj: AgreementData) {
    this.attachmentBottom = false;
    this.agreementCreate.additionalagreement = agreeementObj.other_agreements;
    this.agreementCreate.total_price = agreeementObj.total_price;
    if (agreeementObj.project_end_date != null) {
      this.agreementCreate.enddate = new Date(agreeementObj.project_end_date);
    }
    if (agreeementObj.offer_expiry_date != null) {
      this.agreementCreate.offerExpirydate = new Date(agreeementObj.offer_expiry_date);
    }
    if (agreeementObj.project_start_date != null) {
      this.agreementCreate.startdate = new Date(agreeementObj.project_start_date);
    }
    if (agreeementObj.is_fixed_price) {
      this.agreementCreate.isTotalFastPrice = agreeementObj.is_fixed_price_direct_total;
      if (this.agreementCreate.isTotalFastPrice) {
        this.agreementCreate.fastpriceTotal = agreeementObj.total_price;
      }
      this.agreementCreate.priceOption1 = 'Fast pris';
      this.agreementCreate.priceOption2 = '';
      this.agreementCreate.priceOption3 = '';
      if (this.agreementCreate.total_price) {
      this.activateLastStepValidation = true;
      }
    }
    if (agreeementObj.is_approximate_price) {
      this.agreementCreate.priceOption2 = 'Ungefärlig prisuppgift';
      this.agreementCreate.priceOption1 = '';
      this.agreementCreate.priceOption3 = '';
      if (this.agreementCreate.total_price) {
        this.activateLastStepValidation = true;
        }
    }
    if (agreeementObj.is_ongoing_bill) {
      this.agreementCreate.priceOption3 = 'Löpande räkning​';
      this.agreementCreate.priceOption1 = '';
      this.agreementCreate.priceOption2 = '';
    }
    this.agreementCreate.fastpriceArbete = agreeementObj.work_cost;
    this.agreementCreate.fastpriceMaterial = agreeementObj.material_cost;
    this.agreementCreate.fastpriceResor = agreeementObj.travel_cost;
    this.agreementCreate.ungefarligprisuppgift = agreeementObj.approximate_cost;
    this.agreementCreate.lopandeArbete = agreeementObj.work_hourly_cost;
    this.agreementCreate.lopandeArbetsledning = agreeementObj.work_flow_hourly_cost;
    this.agreementCreate.lopandeOverenskomna = agreeementObj.sub_contract_cost_rate;
    this.agreementCreate.lopandeMaterial = agreeementObj.other_cost_rate;
    this.agreementCreate.sellercompanyinsurance = agreeementObj.risk_and_liability;
    this.agreementCreate.uploaded_links = agreeementObj.uploaded_links;
    if (agreeementObj.uploaded_links != null) {
      this.agreementCreate.uploaded_links = agreeementObj.uploaded_links;
    } else {
      this.agreementCreate.uploaded_links = [];
    }
    this.agreementCreate.buyerworkspecification = agreeementObj.work_and_materials;
    this.agreementCreate.buyerworkExecuted = agreeementObj.work_if_craft_man_declined;
    if (agreeementObj.status !== 2) {
      this.agreementCreate.buyerworknotrecommended = agreeementObj.reason_for_rejection;
    }
    if (agreeementObj.is_with_ROT_deduction) {
      this.agreementCreate.taxdeduction = 'Yes';
    } else {
      this.agreementCreate.taxdeduction = 'No';
    }
    this.agreementCreate.propertyId = agreeementObj.condominium_designation;
    this.agreementCreate.propertyorgno = agreeementObj.association_org_no;
    this.agreementCreate.individualtaxdeduction = agreeementObj.ROT_deduction_client;
    this.agreementCreate.hourlyPriceadditionalwork = agreeementObj.hourly_rate_for_work;
    this.agreementCreate.hourlyPriceadditionalworkManage = agreeementObj.hourly_rate_for_work_management;
    this.agreementCreate.paymentOption1 = agreeementObj.is_additional_work_pay_on_invoice;
    this.agreementCreate.paymentOption2 = agreeementObj.is_entire_payment_done_after_work_done;
    this.agreementCreate.paymentOption3 = agreeementObj.is_payment_done_according_to_payment_plan;
    this.agreementCreate.paymentOption4 = agreeementObj.is_specified_invoice;
    this.agreementCreate.lopandeResorDetails = agreeementObj.travel_charge_details;

    this.activateSecondStepValidation = true;
  }

  momentDateFormat(date, dateformat): Date {
    return moment(date, dateformat).toDate();
  }

  // Payment Checking
  onFilterChange(event: any, option) {
    if (option === 'paymentOption2' || option === 'paymentOption3') {
      if (option === 'paymentOption2' && event) {
        this.agreementCreate.paymentOption3 = false;
      }

      if (option === 'paymentOption3' && event) {
        this.agreementCreate.paymentOption2 = false;
      }
    }
  }

  // generate by by from category
  // generatedPdfDetails() {
  //  console.log(this.commonService.getgeneratedpdf());
  // }

  // Remove the Attachment
  removeAttachmentAppendex() {
    this.attachmentBottom = false;
    this.generatedbodyAttachment = '';
  }

  callgeneratedhtmlFile() {
    this.attachmentcreatedDate = new Date();
    this.attachmentBottom = true;
    this.generatedbodyAttachment = this.commonComponent.getgeneratedpdf();
  }




  // =================================================== END AGREEMENT CREATE OFFER ===================================================
  //#endregion

  //#region Project Complete and cancelled the Project

  // Open Close Project
  closeProjectModalOpen() {
    if (this.isEditableOptionEnable) {
      this.righttabIdentify = 'overview';
      this.globalEventsManager.sendopenConfirmationModal(true);
      return;
    } else {
      this.isCheckedProjectStatus = false;
      // this.openCloseprojectModal.nativeElement.click();
      $(this.openModalClose.nativeElement).modal('show');
    }
  }
  // Project Complete or cancel Status Call button click
  callProjectFinalStatus(statusname) {
    this.isCheckedProjectStatus = true;
    this.Selectedprojectstatus = statusname;
  }

  // Project Complete Status Call button click
  callProjectCompleteStatus() {
    // tslint:disable-next-line:prefer-const
    let userDetails = this.cognitoService.getCurrentUser();
    // tslint:disable-next-line:prefer-const
    let body = {
      project_id: this.projectId,
      seller_username: userDetails.username,
      review_url: environment.buyerendlink + '/buyer/safetybox/review'
    };
    this.loaderActivate = true;
    this.displayarchiveprojectlistnames = this.projectDetails.project_name;
    this.sellerService.projectCompletedRequest(body).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
       // Archive Notification
       this.getNotificationArchivemoverecntly(this.currentSellerId);
      this.getArchiveProjectLists();
      this.closeprojectModal.nativeElement.click();
      this.calltoRemoveTabFromProjectList(this.projectId, this.tabIndentification);
      console.log('Completed the Project --- ' + res);
      this.callTabIdentify('archive');

    }, err => {
      console.log(err);
    });
  }

  // Project cancelled Status Call button click
  callProjectCancelledStatus() {
    // tslint:disable-next-line:prefer-const
    let userDetails = this.cognitoService.getCurrentUser();
    // tslint:disable-next-line:prefer-const
    let body = {
      project_id: this.projectId,
      seller_username: userDetails.username,
      review_url: environment.buyerendlink + '/buyer/safetybox/review'
    };
    this.loaderActivate = true;
    this.sellerService.projectCancelledRequest(body).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      // Archive Notification
      this.getNotificationArchivemoverecntly(this.currentSellerId);
      this.getArchiveProjectLists();
      this.closeprojectModal.nativeElement.click();
      this.calltoRemoveTabFromProjectList(this.projectId, this.tabIndentification);
      console.log('Cancel the Project --- ' + res);
      this.callTabIdentify('archive');

    }, err => {
      console.log(err);
    });
  }



  // Complete Change
  callCompletedArchiveTab(selected) {
    if (this.isCancelledArchive && selected === 'completed') {
      this.isCancelledArchive = false;
      this.archiveCompletedProjects = this.completedProjects;
      this.callTabIdentify('archive');
    } else if (!this.isCancelledArchive && selected === 'cancel') {
      this.isCancelledArchive = true;
      this.archiveCompletedProjects = this.archiveProjects;
      this.callTabIdentify('archive');
    }
  }

  // Call to Remove Object From Other Tabs
  calltoRemoveTabFromProjectList(projectid, tabIdentity) {
    if (tabIdentity === 'activeProjects') {
      // tslint:disable-next-line:prefer-const
      let index = this.agreedProjects.findIndex(x => x.project_id === projectid);
      if (index > -1) {
        this.agreedProjects.splice(index, 1);
      }
    } else {
      // tslint:disable-next-line:prefer-const
      let index = this.acceptedProjects.findIndex(x => x.project_id === projectid);
      if (index > -1) {
        this.acceptedProjects.splice(index, 1);
      }
    }
  }

  //#endregion

  //#region Co Worker's Chat Start
  // tslint:disable-next-line:max-line-length
  // =================================================== START Co Workers Chat Implementation ===================================================

  // Get the Worker's List from the Projects
  getAllWorkersList(projectid: number): void {
    this.workerlist = [];
    this.loaderActivate = true;
    // Call workers by Projects
    this.sellerService.getWorkersByprojectId(projectid).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.workerlist = res;
        if (this.workerlist.length > 0) {
          this.workerInformation = this.workerlist[0];
        }
      }
    }, err => {
      console.log(err);
    });
  }

  // Call worker Information
  callworkerInformation(workerid: number): void {
    // this.loaderActivate = true;
    // Call workers by Projects
    this.sellerService.getWorkerInformation(workerid).finally(() => {
      // this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.workerInformation = res;
      }
    }, err => {
      console.log(err);
    });
  }

  // Send Message Co Workers
  sendMessageCoWorkersBtnClicked(): void {
    // if attachment is available, upload it to s3 bucket
    if (this.fileDataCoWorker.length > 0) {
      this.uploadAttachedFileCoWorker();
    } else {
      if (this.messageToSendCoWorkers) {
        this.messageToSendCoWorkers = this.messageToSendCoWorkers.substring(0, this.messageToSendCoWorkers.length - 1);
        if (this.messageToSendCoWorkers) {
          this.sendMessageToCoWorkers();
        }
      } else {
        this.messageToSendCoWorkers = '';
      }
    }
  }

  sendEnterFunctionSendMessageBtnCoWorkers($vent) {
    this.sendMessageCoWorkersBtnClicked();
  }


  // upload attached file into s3 bucket
  public uploadAttachedFileCoWorker() {
    if (!this.fileDataCoWorker || this.fileDataCoWorker.length <= 0) {
      return;
    }
    let filename = '';
    this.fileDataCoWorker.forEach((element, index) => {
      this.attachedFileType = element.type;
      this.uploadingAttachmentCoWorker = true;
      filename = element.file.name;
      // call file upload
      this.sellerService.uploadAttachedFile(element.file, this.projectDetails.project_id, this.currentUserId,
        this.attachedFileType, CommonConstants.ACTIVITY_TYPE_INTERNAL, true).subscribe(res => {
          if (res !== 'No file part') {
            this.attachmentUrlCoWorker = res.activity_url;
            // tslint:disable-next-line:prefer-const
            let newMessage = new MessageModel(this.currentUserId,
              this.currentUserId, '',
              this.attachmentUrlCoWorker, res.file_type, new Date().toUTCString(), 1, filename);
            this.firebaseHelperService.sendMessageToCoWorkers(this.projectDetails.project_id,
              this.currentSellerId, this.currentUserId, newMessage);
            const link = environment.frontendlink +
              '/seller/safetybox?requestto=safetybox&requesttype=internal&projectid=' + this.projectDetails.project_id;
            // call Push notification
            this.sendPushNotification(this.projectDetails.project_id,
              this.currentUserId, 0,
              this.getpushnotificationfiletype(res.file_type), link);

                  // call Push notification IOS
            this.sendPushNotification_ios(this.projectDetails.project_id,
              this.currentUserId, 0,
              this.getpushnotificationfiletype(res.file_type), link);

            // clear message typing text box and attachment details
            // this.messageToSendCoWorkers = '';
            this.removeAttachedFileCoWorker();
          }
          this.uploadingAttachmentCoWorker = false;
          // if (res) {
          //   this.attachmentUrlCoWorker = res;
          //   // send message
          //   this.sendMessageToCoWorkers();
          //   this.uploadingAttachmentCoWorker = false;
          // }
        }, err => {
          console.log(err);
          this.uploadingAttachmentCoWorker = false;
        });
      if (this.fileDataCoWorker.length - 1 === index) {
        this.removeAttachedFileCoWorker();
        this.isScrollToBottomCoWorker = true;
      }
    });
  }

  // send message - save message data into firebase database
  private sendMessageToCoWorkers() {
    // send message
    // tslint:disable-next-line:prefer-const
    let newMessage = new MessageModel(this.currentUserId,
      this.currentUserId, this.messageToSendCoWorkers,
      this.attachmentUrlCoWorker, this.attachedFileType, new Date().toUTCString(), 1, '');
    this.firebaseHelperService.sendMessageToCoWorkers(this.projectDetails.project_id,
      this.currentSellerId, this.currentUserId, newMessage);
    const link = environment.frontendlink +
      '/seller/safetybox?requestto=safetybox&requesttype=internal&projectid=' + this.projectDetails.project_id;
    // call Push notification
    this.sendPushNotification(this.projectDetails.project_id,
      this.currentUserId, 0, this.messageToSendCoWorkers, link);

    // call Push notification IOS
    this.sendPushNotification_ios(this.projectDetails.project_id,
      this.currentUserId, 0, this.messageToSendCoWorkers, link);

    // Read Issue
    this.removecountFromUnloadCoworkers(this.projectDetails.project_id);

    // clear message typing text box and attachment details
    this.messageToSendCoWorkers = '';
    this.removeAttachedFileCoWorker();
    this.isScrollToBottomCoWorker = true;
  }

  // Update Unread Messages
  removecountFromUnloadCoworkers(projectid) {
    this.unReadMessageCoWorkerCount.forEach((item, index) => {
      if (item.projectid === projectid) {
        this.unReadMessageCoWorkerCount[index].count = 0;
        this.globalEventsManager.sendMessageArrayCoWorker(this.unReadMessageCoWorkerCount);
      }
    });
  }

  // remove attachment Co Workers
  public removeAttachedFileCoWorker() {
    this.attachmentUrlCoWorker = '';
    this.attachedFileDisplayUrlCoWorker = '';
    this.attachedFileDisplayNameCoWorker = '';
    this.attachedFileType = '';
    this.fileDataCoWorker = [];
    this.fileuploaderrormessage = '';
    this.fileDataCoDisplay = [];

  }

  // Remove Uploaded Files
  removeAttachedFileUploadCoWorker(item: any, ind: number): void {
    if (this.fileDataCoDisplay.length > ind) {
      this.fileDataCoDisplay.splice(ind, 1);
      this.fileDataCoWorker.forEach((element, index) => {
        if (element.file.name === item.name) {
          this.fileDataCoWorker.splice(index, 1);
        }
      });
    }
  }

  // attach file by upload button click
  public attachFileByInputClickCoWorker(event) {
    this.fileDataCoWorker = [];
    if (event.target.files && event.target.files[0]) {
      for (let index = 0; index < event.target.files.length; index++) {
        this.attachFileCoWorker(event.target.files[index]);
      }
    }
  }

  // attach file by drop file into drop zone
  public attachFileByDropCoWorker(event: UploadEvent) {
    this.fileDataCoWorker = [];
    // tslint:disable-next-line:prefer-const
    // let droppedFile = event.files[0];
    if (event.files && event.files[0]) {
      for (let index = 0; index < event.files.length; index++) {
        // this.attachFileCoWorker();
        const fileEntry = event.files[index].fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          if (file) {
            this.attachFileCoWorker(file);
          }
        });
      }
    }
  }

  // attaching the file that uploaded by drag drop and by button click
  private attachFileCoWorker(file: File) {
    // set attachment file type and validate file size according to file type
    if (!this.setFileTypeAndValidate(file.type, file.size, file.name, 'Internal')) {
      this.fileDataCoWorker = [];
      this.fileDataCoDisplay = [];
      return;
    }
    this.fileDataCoWorker.push({ file: file, type: this.attachedFileType });
    // this.fileDataCoWorker.push(file);

    // to display attached file
    this.attachedFileDisplayNameCoWorker = file.name;

    if (this.attachedFileType === CommonConstants.FILE_TYPE_IMAGE) {
      // tslint:disable-next-line:prefer-const
      let reader = new FileReader();
      reader.onload = (event: any) => {
        this.attachedFileDisplayUrlCoWorker = event.target.result;
        this.fileDataCoDisplay.push({
          name: this.attachedFileDisplayNameCoWorker,
          url: this.attachedFileDisplayUrlCoWorker
        });
      };
      reader.readAsDataURL(file);
    } else {
      this.fileDataCoDisplay.push({
        name: this.attachedFileDisplayNameCoWorker,
        url: this.attachedFileDisplayUrlCoWorker
      });
    }
  }

  // get worker profile name to display
  getBuyerNameForInternalChat(user_id): string {
    this.workerlist.filter(val => {
      if (val.user_id === user_id) {
        if (val.worker_name != null) {
          this.recipientProfilePicNameInitialsCoWorker = val.worker_name.split('')[0];
        }
      }
    });
    return this.recipientProfilePicNameInitialsCoWorker;
  }

  // get worker Name to display
  getworkerFullNameTodisplay(user_id): string {
    // tslint:disable-next-line:prefer-const
    let stringname = '';
    this.workerlist.filter(val => {
      if (val.user_id === user_id) {
        if (val.worker_name != null) {
          stringname = val.worker_name;
        }
      }
    });
    return stringname;
  }

  checkEvent($event) {
    this.messageToSend = $event.textValue;
  }




  // tslint:disable-next-line:max-line-length
  // ================================================ END Co Workers Chat Implementation ===================================================
  //#endregion


  //#region Change Agreement Create PDf html


  // Call the Agreement
  callValidationChangeAgreement(index) {
    if (this.isvalidation) {
      if (this.changeActiveStep === 2) {
        if (index === 1) {
          this.changeActiveStep = index;
        } else {
          this.secondStepAdditionalAgreement.nativeElement.click();
        }
      } else {
        this.changeActiveStep = index;
      }
    } else {
      if (index === 3 || index === 4) {
        this.secondStepAdditionalAgreement.nativeElement.click();
        this.changeActiveStep = 2;
      } else {
        this.changeActiveStep = index;
      }
    }
  }

  // Call the Previous Agreement Informatioon
  getLatestAgreementInformation() {
    this.changeActiveStep = 1;
    this.isvalidation = false;
    this.changeAgreementObject.agreement_name = undefined;
    this.changeAgreementObject.work_scope = undefined;
    this.selectedextraservice = [];
    this.selectedextraServiceCategories = [];
    this.changeAgreementObject.is_debited = true;
    this.priceOptionChangeAgreement('Fast pris');
    this.loaderActivate = true;
    this.sellerService.getAgreementInfomrationByagreementId(this.agreementparentId, 0).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.setChangeAgreementValueupdate(res);
      }
    }, err => {
      console.log(err);
    });
  }

  // Set the value From Main Agreement..
  setChangeAgreementValueupdate(Obj) {
    if (Obj.project_end_date != null) {
      this.changeAgreementObject.enddate = new Date(Obj.project_end_date);
    }
    // if (Obj.offer_expiry_date != null) {
    //   this.agreementCreate.offerExpirydate = new Date(Obj.offer_expiry_date);
    // }
    if (Obj.project_start_date != null) {
      this.changeAgreementObject.startdate = new Date(Obj.project_start_date);
    }
  }

  onFileChangeAgreement(event) {
    // tslint:disable-next-line:prefer-const
    let reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      for (let index = 0; index < event.target.files.length; index++) {
        // tslint:disable-next-line:prefer-const
        let file = event.target.files[index];
        this.loaderActivate = true;
        this.sellerService.uploadagreementbrowsefile(this.projectId, file).finally(() => {
          this.loaderActivate = false;
        }).subscribe(res => {
          if (res != null) {
            this.changeAgreementObject.uploaded_links.push(res);
          }
        }, err => {
          console.log(err);
        });
      }
    }
  }

  // Call the Cancel uploaded images in Step 2 section
  removebrowseChangeAgreementAttachFiles(i): void {
    this.changeAgreementObject.uploaded_links.splice(i, 1);
  }

  // Get Extra Service Categories
  getExtraServiceCategories() {
    this.sellerService.getExtraServiceCategories().subscribe(res => {
      if (res != null) {
        this.extraServiceCategories = res;
      }
    }, err => {
      console.log(err);
    });
  }

  // Extra service count
  selectExtraServiceCategory(item, index) {
    if (this.selectedextraservice[index]) {
      this.selectedextraServiceCategories.push(item);
    } else {
      this.selectedextraServiceCategories.map((ite, ivalue) => {
        if (ite.extra_service_category_id === item.extra_service_category_id) {
          this.selectedextraServiceCategories.splice(ivalue, 1);
        }
      });
    }
  }


  priceOptionChangeAgreement(optionValueData: string): void {
    if (optionValueData === 'Fast pris') {
      this.changeAgreementObject.priceOption1 = 'Fast pris';
      this.changeAgreementObject.priceOption2 = '';
      this.changeAgreementObject.priceOption3 = '';
      if (this.changeAgreementObject.isTotalFastPrice) {
        this.changeAgreementObject.total_price = this.changeAgreementObject.fastpriceTotal;
      } else {
        this.changeAgreementObject.total_price = this.changeAgreementObject.fastpriceArbete +
          this.changeAgreementObject.fastpriceMaterial + this.changeAgreementObject.fastpriceResor;
      }
    } else if (optionValueData === 'Ungefärlig prisuppgift') {
      this.changeAgreementObject.priceOption1 = '';
      this.changeAgreementObject.priceOption2 = 'Ungefärlig prisuppgift';
      this.changeAgreementObject.priceOption3 = '';
      this.changeAgreementObject.total_price = this.changeAgreementObject.ungefarligprisuppgift;
    } else if (optionValueData === 'Löpande räkning​') {
      this.changeAgreementObject.priceOption1 = '';
      this.changeAgreementObject.priceOption2 = '';
      this.changeAgreementObject.priceOption3 = 'Löpande räkning​';
    }

  }

  // on change the Fast Price Issue
  onChangeFastPriceChangeAgreement(): void {
    if (this.changeAgreementObject.isTotalFastPrice) {
      this.changeAgreementObject.total_price = this.changeAgreementObject.fastpriceTotal;
    } else {
      this.changeAgreementObject.total_price = this.formatPriceValues(this.changeAgreementObject.fastpriceArbete) +
        this.formatPriceValues(this.changeAgreementObject.fastpriceMaterial) +
        this.formatPriceValues(this.changeAgreementObject.fastpriceResor);
    }
  }

  // Price Option 2
  onChangePriceOption2ChangeAgreement() {
    this.changeAgreementObject.total_price = this.changeAgreementObject.ungefarligprisuppgift;
  }

  getYasoFeeCalculationChangeAgreement(): number {
    let yasoofee = 0;
    if (this.changeAgreementObject.priceOption1 === 'Fast pris') {
      if (this.changeAgreementObject.isTotalFastPrice) {
        yasoofee = this.changeAgreementObject.fastpriceTotal * 0.03;
      } else {
        yasoofee = (this.changeAgreementObject.fastpriceArbete + this.changeAgreementObject.fastpriceMaterial +
          this.changeAgreementObject.fastpriceResor) * 0.03;
      }

      if (yasoofee > 500) {
        if (yasoofee > 3000) {
          return 3000;
        }
        return yasoofee;
      } else {
        return 500;
      }
    } else if (this.changeAgreementObject.priceOption2 === 'Ungefärlig prisuppgift') {
      yasoofee = this.changeAgreementObject.ungefarligprisuppgift * 0.03;
      if (yasoofee > 500) {
        if (yasoofee > 3000) {
          return 3000;
        }
        return yasoofee;
      } else {
        return 500;
      }
    } else if (this.changeAgreementObject.priceOption3 === 'Löpande räkning​') {
      return 999;
    }

  }

  // Call next Step
  callNextstepInChangeAgreement() {
    if (this.changeActiveStep === 1) {
      this.firstStepAdditionalAgreement.nativeElement.click();
      // this.changeActiveStep = 2;
    } else if (this.changeActiveStep === 2) {
      this.secondStepAdditionalAgreement.nativeElement.click();
      // this.changeActiveStep = 3;
    } else if (this.changeActiveStep === 3) {
      this.changeActiveStep = 4;
    }
  }

  // Call the Form
  changeagreementCreateStep1NextLevel(model: any, isValid: boolean, step: string): void {
    this.isestraerrormessage = false;
    if (!isValid) {
      return;
    }
    if (this.changeActiveStep === 1) {
      this.changeActiveStep = 2;
    } else if (this.changeActiveStep === 2) {
      if (this.selectedextraServiceCategories.length === 0) {
        this.isestraerrormessage = true;
        return;
      } else if (this.worksScopeLength > 2000) {
        return;
      } else {
        this.changeActiveStep = 3;
        this.isvalidation = true;
      }
    } else if (this.changeActiveStep === 3) {
      this.changeActiveStep = 4;
    }
  }

  CreateChangeAgreementPdf() {

    // tslint:disable-next-line:prefer-const
    let pricestringhtml = '';
    // tslint:disable-next-line:prefer-const
    let billablehourshtml = '';
    // tslint:disable-next-line:prefer-const
    let lopanderakning = '';
    // tslint:disable-next-line:prefer-const
    let resoroptionfinal = '';
    // tslint:disable-next-line:prefer-const
    // tslint:disable-next-line:prefer-const
    let optionalNumber = '';

    // identitynumberperson1
    if (typeof this.changeAgreementObject.identitynumberperson1 === 'undefined') {
      this.changeAgreementObject.identitynumberperson1 = '';
    }
    // identitynumberperson 2
    if (typeof this.changeAgreementObject.identitynumberperson2 === 'undefined') {
      this.changeAgreementObject.identitynumberperson2 = '';
    }

    // tslint:disable-next-line:typeof-compare
    if (typeof this.changeAgreementObject.firstStepPhonenumber1 === 'undefined') {
      optionalNumber = '';
    } else {
      optionalNumber = this.changeAgreementObject.firstStepPhonenumber1.toString();
    }

    if (typeof this.changeAgreementObject.nameperson2 === 'undefined') {
      this.changeAgreementObject.nameperson2 = '';
    }

    if (typeof this.changeAgreementObject.sellercompanyinsurance === 'undefined') {
      this.changeAgreementObject.sellercompanyinsurance = '';
    }

    // tslint:disable-next-line:prefer-const this.formatDate(this.attachmentcreatedDate)  +
    // let uploadlinks = '<tr>' +
    //   '                        <td height="20" colspan="1">Arbetet ska också utföras enligt' +
    //   '                                <span class="pl-2 text-secondary"></span>' +
    //   '                            </td>' +
    //   '                        </tr>';
    // let attachmentDescription = '';
    //   attachmentDescription = '<tr>' +
    //   '                           <td colspan="2">' + 'Arbete ska utföras enligt arbetsbeskrivning som ses i avtalets Appendix' +
    //   '                              <span class="pl-2 text-secondary">  </span>' +
    //   '                           </td>' +
    //   '                        </tr>';
    //   uploadlinks = attachmentDescription + uploadlinks ;


    // tslint:disable-next-line:prefer-const
    let pagebreakfirsttwo = '';
    // tslint:disable-next-line:prefer-const
    let pagebreaklastprice = '';
    // tslint:disable-next-line:prefer-const
    let pageHbreaklastprice = '';
    // tslint:disable-next-line:prefer-const
    let pageFbreaklastprice = '';
    // tslint:disable-next-line:prefer-const
    let pageGbreaklastprice = '';
    // tslint:disable-next-line:prefer-const
    let pageJbreaklastprice = '';
    // tslint:disable-next-line:prefer-const
    let totalPriceDefine = '';
    if (this.changeAgreementObject.priceOption1 === 'Fast pris') {

      if (this.changeAgreementObject.isTotalFastPrice) {
        pricestringhtml = '<!-- billable hours -->' +
          '          <div class="col-12 border-secondary">' +
          '            <div id="billableHours">' +
          '              <div class="row mt-4">' +
          '                <h5>Fast pris</h5>' +
          '              </div>' +
          '              <div class="row mt-2">' +
          '<div class="table-responsive">' +
          '<table class="table table-bordered">' +
          '                     <tbody>' +
          '<tr>' +
          '                           <td colspan="1">Totalpris projekt (inkl. moms)' +
          '                              <span class="text-secondary">' +
          this.formatPriceValuesPDF(this.changeAgreementObject.fastpriceTotal) + '</span>' +
          '                           </td>' +
          '                        </tr>' +
          '</tbody>' +
          '                  </table>' +
          '</div>' +
          '              </div>' +
          '            </div>' +
          '          </div>';
      } else {
        // tslint:disable-next-line:prefer-const
        let fastprice = this.changeAgreementObject.fastpriceArbete + this.changeAgreementObject.fastpriceMaterial
          + this.changeAgreementObject.fastpriceResor;
        pricestringhtml =
          '          <div class="col-12 border-secondary">' +
          '<div id="fixedPrice">' +
          '              <div class="row mt-4">' +
          '                <h5>Fast pris</h5>' +
          '              </div>' +
          '              <div class="row mt-4">' +
          '<div class="table-responsive">' +
          '<table class="table table-bordered">' +
          '                     <tbody>' +
          '<tr>' +
          '                           <td colspan="1">Totalpris för arbete, material och resor ' +
          '                              <span class="text-secondary">' +
          this.formatPriceValuesPDF(this.formatPriceValues(this.changeAgreementObject.fastpriceArbete) +
            this.formatPriceValues(this.changeAgreementObject.fastpriceMaterial)
            + this.formatPriceValues(this.changeAgreementObject.fastpriceResor)) + '</span> kr inklusive moms' +
          '                           </td>' +
          '                        </tr>' +
          '<tr>' +
          '                           <td colspan="1">Arbete ' +
          '                              <span class="text-secondary">' +
          this.formatPriceValuesPDF(this.formatPriceValues(this.changeAgreementObject.fastpriceArbete)) + '</span> kr inklusive moms' +
          '                           </td>' +
          '                        </tr>' +
          '<tr>' +
          '                           <td colspan="1">Material ' +
          '                              <span class="text-secondary">' +
          this.formatPriceValuesPDF(this.formatPriceValues(this.changeAgreementObject.fastpriceMaterial)) +
          '</span> kr inklusive moms' +
          '                           </td>' +
          '                        </tr>' +
          '<tr>' +
          '                           <td colspan="1">Resor ' +
          '                              <span class="text-secondary">' +
          this.formatPriceValuesPDF(this.formatPriceValues(this.changeAgreementObject.fastpriceResor)) +
          '</span> kr inklusive moms' +
          '                           </td>' +
          '                        </tr>' +
          '</tbody>' +
          '                  </table>' +
          '</div>' +
          '              </div>' +
          '            </div>' +
          '            </div>';
      }

      totalPriceDefine = '<tr><td colspan="2">Project cost' +
        '                              <span class="pl-2 text-secondary">'
        + this.formatPriceValuesPDF(this.changeAgreementObject.total_price) + ' kr</span>' +
        '                           </td> </tr>';


    }

    if (this.changeAgreementObject.priceOption2 === 'Ungefärlig prisuppgift') {
      billablehourshtml =
        '<!-- billable hours -->' +
        '          <div class="col-12 border-secondary">' +
        '            <div id="billableHours">' +
        '              <div class="row mt-4">' +
        '                <h5>Ungefärlig prisuppgift</h5>' +
        '              </div>' +
        '              <div class="row mt-4">' +
        '<div class="table-responsive">' +
        '<table class="table table-bordered">' +
        '                     <tbody>' +
        '<tr>' +
        '                           <td colspan="1">Ungefärlig prisuppgift' +
        '                              <span class="text-secondary">' +
        this.formatPriceValuesPDF(this.changeAgreementObject.ungefarligprisuppgift) +
        '</span> kr (avser arbete och material om inget annat anges) inklusive moms.' +
        '                           </td>' +
        '                        </tr>' +
        '</tbody>' +
        '                  </table>' +
        '</div>' +
        '              </div>' +
        '            </div>' +
        '            </div>';

      totalPriceDefine = '<tr><td colspan="2">Project cost' +
        '                              <span class="pl-2 text-secondary">' +
        this.formatPriceValuesPDF(this.changeAgreementObject.total_price) + ' kr</span>' +
        '                           </td> </tr>';

    }


    if (this.changeAgreementObject.priceOption3 === 'Löpande räkning​') {
      lopanderakning = '<!-- billable hours -->' +
        '          <div class="col-12 border-secondary">' +
        '            <div id="billableHours">' +
        '              <div class="row mt-4">' +
        '                <h5>Löpande räkning</h5>' +
        '              </div>' +
        '              <div class="row mt-2">' +
        '<div class="table-responsive">' +
        '<table class="table table-bordered">' +
        '                     <tbody>' +
        '<tr>' +
        '                           <td>Arbete' +
        '                              <span class="text-secondary">' +
        this.formatPriceValuesPDF(this.changeAgreementObject.lopandeArbete) + '</span> kr/tim inklusive entreprenörarvode och moms.' +
        '                           </td>' +
        '                        </tr>' +
        '<tr>' +
        '                           <td>Arbetsledning' +
        '                              <span class="text-secondary">' +
        this.formatPriceValuesPDF(this.changeAgreementObject.lopandeArbetsledning) +
        '</span> kr/tim inklusive entreprenörarvode och moms.' +
        '                           </td>' +
        '                        </tr>' +
        '<tr>' +
        '                           <td>Överenskomna underentreprenader debiteras med redovisad' +
        ' självkostnad med tillägg för entreprenörarvode om' +
        '                              <span class="text-secondary">' +
        this.formatPriceValuesPDFPercentage(this.changeAgreementObject.lopandeOverenskomna) + '</span>%. Moms tillkommer.' +
        '                           </td>' +
        '                        </tr>' +
        '<tr>' +
        '                           <td>Material, varor, hjälpmedel och övriga' +
        ' kostnader debiteras med redovisad själv kostnad med tillägg för entreprenörarvode om ' +
        '                              <span class="text-secondary">' +
        this.formatPriceValuesPDFPercentage(this.changeAgreementObject.lopandeMaterial) + '</span> %. Moms tillkommer.' +
        '                           </td>' +
        '                        </tr>' +
        '<tr>' +
        '                           <td>Resor' +
        '                              <span class="text-secondary">' +
        this.removeundefinevalue(this.changeAgreementObject.lopandeResorDetails) + '</span>' +
        '                           </td>' +
        '                        </tr>' +
        '</tbody>' +
        '                  </table>' +
        '</div>' +
        '              </div>' +
        '            </div>' +
        '          </div>';


      resoroptionfinal = '<div class="col-12 pl-5">' +

        '          </div>';


      totalPriceDefine = '<tr><td style="width: 20%">Project cost' +
        '</td> <td width: 80%;">' +
        '<div class="table-responsive" style="overflow-x: hidden;overflow-y: hidden">' +
        '<table class="table">' +
        '                     <tbody>' +
        '<tr><td colspan="1" style="border:0 !important;"><h5>Löpande räkning</h5>' +
        '</td> </tr>' +
        '<tr>' +
        '<td colspan="2">Arbete timkostnad (inkl. moms och entreprenörarvode)' +
        '    <span class="pl-2 text-secondary">' + this.formatPriceValuesPDF(this.changeAgreementObject.lopandeArbete) +
        '</span> kr/timme' +
        '                           </td>' +
        '</tr>' +
        '<tr>' +
        '<td colspan="2">Arbetsledning timkostnad (inkl. moms och entreprenörarvode)' +
        '    <span class="pl-2 text-secondary">' + this.formatPriceValuesPDF(this.changeAgreementObject.lopandeArbetsledning) +
        '</span> kr/timme' +
        '                           </td>' +
        '</tr>' +
        '<tr>' +
        '<td colspan="2">Överenskomna underentreprenader debiteras med redovisad självkostnad med tillägg för entreprenörarvode om' +
        '    <span class="pl-2 text-secondary">' +
        this.formatPriceValuesPDFPercentage(this.changeAgreementObject.lopandeOverenskomna) + '</span> % (moms tillkommer)' +
        '                           </td>' +
        '</tr>' +
        '<tr>' +
        '<td colspan="2">Material, varor, hjälpmedel och övriga kostnader debiteras med redovisad' +
        ' självkostnad med tillä̈gg för entreprenörarvode om' +
        '    <span class="pl-2 text-secondary">' +
        this.formatPriceValuesPDFPercentage(this.changeAgreementObject.lopandeMaterial) + '</span> % (moms tillkommer)' +
        '                           </td>' +
        '</tr>' +
        '<tr>' +
        '<td colspan="2">Resor debiteras enligt' +
        '    <span class="pl-2 text-secondary">'
        + this.removeundefinevalue(this.changeAgreementObject.lopandeResorDetails) + '</span>' +
        '                           </td>' +
        '</tr>'
        +
        '</tbody>' +
        '                  </table>' +
        '</div>' +
        '</td></tr>';
    }


    // tslint:disable-next-line:prefer-const
    let finalCTabContent = '';
    if (this.changeAgreementObject.is_debited) {
      finalCTabContent = '<div class="row">' +
        '               <div class="table-responsive">' +
        '                  <table class="table">' +
        '                     <tbody>' +
        '                        <tr>' +
        '                           <td style="width: 50%;text-align: left; vertical-align: middle;">' +
        '<button type="button" class="btn btn-secondary btn-extrawidth" style="margin-left:-10px">DEBITERING +</button>' +
        '                           </td>' +
        // '                           <td style="width: 50%;text-align: center; vertical-align: middle;">' +
        // '                              <button type="button" class="btn btn-extrawidth">KREDITERING -</button>' +
        // '                           </td>' +
        '                        </tr>' +
        '                     </tbody>' +
        '                  </table>' +
        '               </div>' +
        '            </div>'
        +
        '        <div class="row">'
        +
        pricestringhtml
        +
        billablehourshtml
        +
        lopanderakning
        +
        resoroptionfinal
        +
        '        </div>';
    } else {
      finalCTabContent = '<div class="row">' +
        '               <div class="table-responsive">' +
        '                  <table class="table">' +
        '                     <tbody>' +
        '                        <tr>' +
        // '                           <td style="width: 50%;text-align: center; vertical-align: middle;">' +
        // '<button type="button" class="btn  btn-extrawidth">DEBITERING + </button>' +
        // '                           </td>' +
        '                           <td style="width: 50%;text-align: left; vertical-align: middle;">' +
        ' <button type="button" class="btn btn-secondary btn-extrawidth" style="margin-left:-10px">KREDITERING - </button>' +
        '                           </td>' +
        '                        </tr>' +
        '                     </tbody>' +
        '                  </table>' +
        '               </div>' +
        '            </div>'
        +
        '        <div class="row">' +
        '               <div class="table-responsive">' +
        '                  <table class="table table-bordered">' +
        '                     <tbody>' +
        '                        <tr>' +
        '                           <td>' +
        'Välj om detta ÄTA innebär en debitering (kostnadsökning) eller kreditering (kostnadsminskning) från grundavtalet ' +
        '<span class="pl-2 text-secondary">' +
        this.removeundefinevalue(this.changeAgreementObject.debit_comment) + ' kr inklusive moms</span>' +
        '                           </td>' +
        '                        </tr>' +
        '                     </tbody>' +
        '                  </table>' +
        '               </div>' +
        '        </div>';
    }


    // tslint:disable-next-line:prefer-const
    let servicecategories = '';
    this.selectedextraServiceCategories.forEach((item, index) => {
      servicecategories = servicecategories +
        '                    <div class="form-check float-left mr-5">' +
        '                      <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" checked>' +
        '                      <label class="form-check-label" for="defaultCheck1">' +
        item.extra_service_category_name +
        '                      </label>' +
        '                    </div>';
    });


    // tslint:disable-next-line:prefer-const
    let htmlstring = '<!doctype html>' +
      '<html lang="en">' +
      '  <head>' +
      '    <!-- Required meta tags -->' +
      '    <meta charset="utf-8">' +
      '    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">' +
      '' +
      '    <!-- Bootstrap CSS -->' +
      // tslint:disable-next-line:max-line-length
      '    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css" integrity="sha384-Gn5384xqQ1aoWXA+058RXPxPg6fy4IWvTNh0E263XmFcJlSAwiGgFAW/dAiS6JXm" crossorigin="anonymous">' +
      '<style>  .ml {' +
      '    margin-left: 20px;' +
      '  }' +
      ' .ml-10 {' +
      '    margin-left: 30px;' +
      '  }' +
      ' .ml30 {' +
      '    margin-left: 30px;' +
      '  }' +
      ' .ml40 {' +
      '    margin-left: 40px;' +
      '  }' +
      ' .ml15 {' +
      '    margin-left: 15px;' +
      '  }' +
      ' label {' +
      '    width: 100% !important;' +
      '  }' +
      '</style>' +
      '    <title>Hantverkarformuläret - 17</title>' +
      '  </head>' +
      '  <body>' +
      '    <div class="container-fluid">' +
      '      <!-- section A -->' +
      '      <div class="container">' +
      '        <div class="row mt-5">' +
      '          <h3>ÄNDRING- OCH TILLÄGGSAVTAL</h3> </div>' +
      // tslint:disable-next-line:max-line-length
      '  <div class="row">  <p>' + this.removeundefinevalue(this.changeAgreementObject.agreement_name) +
      '</p> ' +
      '        </div>' +
      '        <div class="row border-secondary border-bottom mt-3">' +
      '          <h5>A. Parter</h5>' +
      '        </div>' +
      '        <div class="row mt-3">' +
      '          <h5 style="width:100%;">Beställare (konsument)</h5> </div>' +
      '     <div class="row"><div class="table-responsive">' +
      '            <table class="table table-bordered">' +
      '              <tbody>' +
      '                <tr>' +
      '                  <td>Namn <span class="pl-2 text-secondary">' + this.changeAgreementObject.nameperson1 + '</span></td>' +
      // tslint:disable-next-line:max-line-length
      '                  <td>Personnummer <span class="pl-2 text-secondary">' + this.changeAgreementObject.identitynumberperson1 + '</span></td>' +
      '                </tr>' +
      '                <tr>' +
      '                  <td>Namn<span class="pl-2 text-secondary">' + this.changeAgreementObject.nameperson2 + '</span></td>' +
      '                  <td>Personnummer<span class="pl-2 text-secondary">' +
      this.changeAgreementObject.identitynumberperson2 + '</span></td>' +
      '                </tr>' +
      '                <tr>' +
      // tslint:disable-next-line:max-line-length
      '                  <td colspan="2">Adress<span class="pl-2 text-secondary">' + this.changeAgreementObject.firstStepAddress + '</span></td>' +
      '                </tr>' +
      '                <tr>' +
      // tslint:disable-next-line:max-line-length
      '                  <td>Telefonnummer<span class="pl-2 text-secondary">' + optionalNumber + '</span></td>' +
      '                  <td>E-post<span class="pl-2 text-secondary">' + this.changeAgreementObject.firstStepemail + '</span></td>' +
      '                </tr>' +
      '              </tbody>' +
      '            </table>' +
      '          </div>' +
      '        </div>' +
      '        <div class="row mt-3">' +
      '          <h5>Hantverkare (näringsidkare)</h5> </div>' +
      '      <div class="row">    <div class="table-responsive">' +
      '            <table class="table table-bordered">' +
      '              <tbody>' +
      '                <tr>' +
      '                  <td>Namn/firma<span class="pl-2 text-secondary">'
      + this.changeAgreementObject.sellerorganization + '</span></td>' +
      // tslint:disable-next-line:max-line-length
      '                  <td>Organisations-/personnummer<span class="pl-2 text-secondary">' + this.changeAgreementObject.sellerregistredNumber + '</span></td>' +
      '                </tr>' +
      '                <tr>' +
      '                  <td colspan="2">Adress<span class="pl-2 text-secondary">' +
      this.changeAgreementObject.sellerAddress + '</span></td>' +
      '                </tr>' +
      '                <tr>' +
      '                  <td>Telefonnummer<span class="pl-2 text-secondary">'
      + this.removeundefinevalue(this.changeAgreementObject.sellerphonenumber) + '</span></td>' +
      '                  <td>E-post<span class="pl-2 text-secondary">' + this.changeAgreementObject.selleremail + '</span></td>' +
      '                </tr>' +
      '                <tr>' +
      '                  <td colspan="2">' +
      '                    <div class="form-check float-left mr-5">' +
      '                      <input class="form-check-input" type="checkbox" value="" id="defaultCheck1" checked>' +
      '                      <label class="form-check-label" for="defaultCheck1">' +
      '                        Godkänd för F-skatt' +
      '                      </label>' +
      '                    </div>' +
      '                    <span>Har allrisk- och ansvarsförsäkring hos - </span> ' + this.changeAgreementObject.sellercompanyinsurance +
      '                  </td>' +
      '                </tr>' +
      '              </tbody>' +
      '            </table>' +
      '          </div>' +
      '        </div>' +
      '      </div>' +
      '<div style="page-break-before:always"> </div>' +
      '      <!-- section B -->'
      +
      '      <div class="container">' +
      '        <div class="row border-secondary border-bottom mt-5">' +
      '          <h5>B. Ändringar och tillägg</h5>' +
      '        </div>' +
      '        <div class="row mt-3">' +
      '                <div class="table-responsive">' +
      '                  <table class="table table-bordered">' +
      '                     <tbody>' +
      '                        <tr>' +
      '                           <td colspan="2"> Avtalsnamn' +
      '                              <span class="pl-2 text-secondary">'
      + this.removeundefinevalue(this.changeAgreementObject.agreement_name) + '</span>' +
      '                           </td>' +
      '                        </tr>' +
      '                        <tr>' +
      '                            <td>Ändringarna omfattar följande områden' +
      '                            </td>' +
      '                        </tr>'
      +
      '                        <tr>' +
      '                            <td  height="100">' +
      servicecategories +
      '                            </td>' +
      '                        </tr>' +
      '                        <tr>' +
      '                           <td colspan="2">Specify the work scope to added/removed/ changed in the project' +
      '                              <span class="pl-2 text-secondary">'
      + this.removeundefinevalue(this.changeAgreementObject.work_scope) + '</span>' +
      '                           </td>' +
      '                        </tr>' +
      '                     </tbody>' +
      '                  </table>' +
      '               </div>' +
      '               </div>' +
      '      </div>'
      +
      '      <!-- section C-->' +
      '      <div class="container">' +
      '        <div class="row border-secondary border-bottom mt-5" style="width:100%;">' +
      '          <h5  style="width:100%;">C. Påverkan på pris</h5>' +
      '        </div>' +
      '        <div class="row mt-3">' +
      '          <p>Välj om detta ÄTA innebär en debitering (kostnadsökning) eller kreditering (kostnadsminskning) från grundavtalet.</p>' +
      '        </div>'
      +
      finalCTabContent
      +

      '      </div>' +
      '      <!-- section D -->' +
      '<div style="page-break-before:always"> </div>' +
      '<div class="container">' +
      ' <div class="row border-secondary border-bottom mt-3">' +
      '               <h5 style="width:100%;">D. Påverkan på tid</h5>' +
      '            </div>' +
      '            <div class="row mt-4">' +
      '               <div class="table-responsive" style="overflow-x: hidden;overflow-y: hidden">' +
      '                  <table class="table table-bordered">' +
      '                     <tbody>' +
      // totalPriceDefine
      // +
      '                        <tr>' +
      '                           <td colspan="2">Start Date' +
      '                              <span class="pl-2 text-secondary">' +
      this.formatDate(this.changeAgreementObject.startdate) + '</span>' +
      '                           </td>' +
      '                        </tr>' +
      '                        <tr>' +
      '                           <td colspan="2">End Date' +
      '                              <span class="pl-2 text-secondary">'
      + this.formatDate(this.changeAgreementObject.enddate) + '</span>' +
      '                           </td>' +
      '                        </tr>' +
      '                        <tr>' +
      '                           <td colspan="2">New End Date' +
      '                              <span class="pl-2 text-secondary">'
      + this.formatDate(this.changeAgreementObject.offerExpirydate) + '</span>' +
      '                           </td>' +
      '                        </tr>' +
      '                     </tbody>' +
      '                  </table>' +
      '               </div>' +
      '            </div>' +
      '</div>' +
      pagebreaklastprice +
      '<div class="container">' +
      '<div class="row mt-4">' +
      ' <table class="table table-bordered">' +
      '                     <tbody>' +
      '                        <tr>' +
      '                           <td height="70">Underskrift hantverkare (näringsidkare) <br/>' +
      '                           </td>' +
      '                           <td>Underskrift beställare (konsument) <br/>' +
      '                           </td>' +
      '                        </tr>' +
      '                        <tr>' +
      '                           <td height="70">Namnförtydligande <br/>' +
      '                           </td>' +
      '                           <td> Namnförtydligande<br/>' +
      '                           </td>' +
      '                        </tr>' +
      '                        <tr>' +
      '                           <td height="70"> Stad / Datum <br/>' +
      '                           </td>' +
      '                           <td height="70"> Stad / Datum <br/>' +
      '                           </td>' +
      '                        </tr>' +
      '                     </tbody>' +
      '                  </table>' +
      '</div>' + '' +
      '</div>'
      +
      this.getAttachmenthtmltagForChangeAgreement()
      +


      '    </div>' +
      '    <!-- Optional JavaScript -->' +
      '    <!-- jQuery first, then Popper.js, then Bootstrap JS -->' +
      // tslint:disable-next-line:max-line-length
      '    <!-- <script src="https://code.jquery.com/jquery-3.2.1.slim.min.js" integrity="sha384-KJ3o2DKtIkvYIK3UENzmM7KCkRr/rE9/Qpg6aAZGJwFDMVNA/GpGFF93hXpG5KkN" crossorigin="anonymous"></script>' +
      // tslint:disable-next-line:max-line-length
      '    <script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.12.9/umd/popper.min.js" integrity="sha384-ApNbgh9B+Y1QKtv3Rn7W3mgPxhU9K/ScQsAP7hUibX39j7fakFPskvXusvfa0b4Q" crossorigin="anonymous"></script>' +
      '    <script src="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/js/bootstrap.min.js" integrity="sha384-JZR6Spejh4U02d8jOt6vLEHfe/JQGiRRSQQxSfFWpi1MquVdAyjUar5+76PVCmYl" crossorigin="anonymous"></script> -->' +
      '  </body>' +
      '</html>';

   // console.log(htmlstring);

    // this.agreementCreate.yosso_fee = this.getYasoFeeCalculation();
    // tslint:disable-next-line:prefer-const
    let createBody = this.getChangeAgreementObject(htmlstring);

    this.loaderActivate = true;
    this.sellerService.createChangeAgreementPdf(createBody).finally(() => {
      this.loaderActivate = false;
    }).subscribe(res => {
      if (res != null) {
        this.closeChangecreateOfferModal.nativeElement.click();
        this.changeActiveStep = 1;
        this.getAgreementFilePath(this.projectId, this.currentSellerId);
        this.isvalidation = false;
      }
    }, err => {
      console.log(err);
    });
  }


  // generate body

  getChangeAgreementObject(htmlstring) {
    // tslint:disable-next-line:prefer-const
    let objChange = new ChangeAgreementDbObject();
    objChange.html_content = htmlstring;
    objChange.project_agreement_id = this.agreementparentId;
    objChange.agreement_name = this.changeAgreementObject.agreement_name;
    objChange.extra_service_category_ids = this.getServicecategoryIds();
    objChange.work_scope = this.changeAgreementObject.work_scope;
    objChange.uploaded_links = this.changeAgreementObject.uploaded_links;
    objChange.is_credited = this.changeAgreementObject.is_credited;
    objChange.is_debited = this.changeAgreementObject.is_debited;
    objChange.credit_comment = this.changeAgreementObject.debit_comment;
    objChange.project_start_date = this.changeAgreementObject.startdate;
    objChange.project_end_date = this.changeAgreementObject.enddate;
    objChange.new_project_end_date = this.changeAgreementObject.offerExpirydate;
    if (this.changeAgreementObject.priceOption1 === 'Fast pris') {
      objChange.is_fixed_price_direct_total = this.changeAgreementObject.isTotalFastPrice;
      objChange.is_fixed_price = true;
      objChange.is_ongoing_bill = false;
      objChange.is_approximate_price = false;
    }
    if (this.changeAgreementObject.priceOption2 === 'Ungefärlig prisuppgift') {
      objChange.is_approximate_price = true;
      objChange.is_fixed_price = false;
      objChange.is_ongoing_bill = false;
    }
    if (this.changeAgreementObject.priceOption3 === 'Löpande räkning​') {
      objChange.is_ongoing_bill = true;
      objChange.is_approximate_price = false;
      objChange.is_fixed_price = false;
    }
    objChange.liability_insurance = this.changeAgreementObject.sellercompanyinsurance;
    objChange.total_price = this.changeAgreementObject.total_price;
    objChange.yosso_fee = this.getYasoFeeCalculationChangeAgreement();
    objChange.work_cost = this.changeAgreementObject.fastpriceArbete;
    objChange.material_cost = this.changeAgreementObject.fastpriceMaterial;
    objChange.travel_cost = this.changeAgreementObject.fastpriceResor;
    objChange.approximate_cost = this.changeAgreementObject.ungefarligprisuppgift;
    objChange.work_hourly_cost = this.changeAgreementObject.lopandeArbete;
    objChange.work_flow_hourly_cost = this.changeAgreementObject.lopandeArbetsledning;
    objChange.sub_contract_cost_rate = this.changeAgreementObject.lopandeOverenskomna;
    objChange.other_cost_rate = this.changeAgreementObject.lopandeMaterial;
    objChange.travel_charge_details = this.changeAgreementObject.lopandeResorDetails;
    objChange.safety_box_link = environment.buyerendlink
      + '/buyer/safetybox?requestto=safetybox&requesttype=activeproject&selectedtab=agreement&sellerid=' + this.currentSellerId
      + '&projectid=';
    return objChange;
  }

  // get Ids Service Categories
  getServicecategoryIds() {
    // tslint:disable-next-line:prefer-const
    let array = [];
    this.selectedextraServiceCategories.forEach(item => {
      array.push(item.extra_service_category_id);
    });

    return array;
  }


  // Generate the Attachments
  getAttachmenthtmltagForChangeAgreement() {
    // tslint:disable-next-line:prefer-const
    let body = '';
    if (this.changeAgreementObject.uploaded_links.length > 0) {
      this.changeAgreementObject.uploaded_links.forEach(element => {
        body = body + '<tr>' +
          '<td colspan="1">' +
          '  <img src="' + element + '" style="height:400px" />' +
          '</td>' +
          '</tr>';
      });

      // tslint:disable-next-line:prefer-const
      let myvar =
        '<div style="page-break-before:always"> </div><div class="container">' +
        ' <div class="row border-secondary border-bottom">' +
        '               <h4>Appendix</h4>' +
        '            </div>' +
        '<div class="row mt-5">' +
        '                <div class="table-responsive">' +
        '                    <table class="table table-bordered">' +
        '                        <tbody>' +
        '                            <tr>' +
        '                                <td>' +
        'Arbetsbeskrivning' +
        '                                </td>' +
        '                            </tr>' +
        '                                   ' +
        body +
        '                                   ' +
        '                        </tbody>' +
        '                    </table>' +
        '                </div>' +
        '            </div>'
        +
        '    </div>';
      return myvar;
    } else {
      return '';
    }

  }

  callWorkScopeTextChange($event) {
    this.worksScopeLength = this.changeAgreementObject.work_scope.length;
  }

  //#endregion

}



// WEBPACK FOOTER //
// ./src/app/seller/safetybox/safetybox.component.ts